// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import { Link } from "react-router-dom";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';

// // API Base URL - Define it once and reuse
// const API_BASE_URL = "https://backend.maamaas.com/subscription/api";

// const REQUIRED_IMAGE_FIELDS = [
//     "Incorporation Certificate",
//     "GST Certificate",
//     "Trade License",
//     "Owner PAN Document",
//     "Owner Aadhaar Document",
//     "Owner Image",
//     "Company PAN Document"
// ];
// const isImageField = (rowKey) => REQUIRED_IMAGE_FIELDS.includes(rowKey);

// // API Endpoints
// const API_ENDPOINTS = {
//     GET_ALL_USERS: `${API_BASE_URL}/admin/getallusers`,
//     COMPANY_VERIFICATION: (userId) => `${API_BASE_URL}/company/verification/${userId}`,
//     COMPANY_VERIFICATION_APPROVE: (userId) => `${API_BASE_URL}/admin/company/verification/approve/${userId}`,
//     COMPANY_VERIFICATION_REJECT: (userId) => `${API_BASE_URL}/admin/company/verification/reject/${userId}`,
//     GET_USER_COMPANY_VERIFICATION: (userId) => `${API_BASE_URL}/user/company/verification/${userId}`,
//     // Add the new status update endpoint
//     UPDATE_VERIFICATION_STATUS: (verificationId) => `${API_BASE_URL}/company/verification/${verificationId}/status`
// };

// const getDefaultClientDetailsRows = () => [
//     { key: "Company Name", value: "", isUpload: false },
//     { key: "Business Type", value: "", isUpload: false },
//     { key: "Company PAN", value: "", isUpload: false },
//     { key: "Company GST", value: "", isUpload: false },
//     { key: "CIN (For Companies)", value: "", isUpload: false },
//     { key: "Registered Address", value: "", isUpload: false },
//     { key: "City", value: "", isUpload: false },
//     { key: "State", value: "", isUpload: false },
//     { key: "Pincode", value: "", isUpload: false },
//     { key: "Incorporation Certificate", value: null, isUpload: true },
//     { key: "GST Certificate", value: null, isUpload: true },
//     { key: "Trade License", value: null, isUpload: true },
//     { key: "Owner Full Name", value: "", isUpload: false },
//     { key: "Owner Date of Birth", value: "", isUpload: false },
//     { key: "Owner PAN", value: "", isUpload: false },
//     { key: "Owner Aadhaar", value: "", isUpload: false },
//     { key: "Owner Mobile", value: "", isUpload: false },
//     { key: "Owner Email", value: "", isUpload: false },
//     { key: "Owner Address", value: "", isUpload: false },
//     { key: "Owner PAN Document", value: null, isUpload: true },
//     { key: "Owner Aadhaar Document", value: null, isUpload: true },
//     { key: "Owner Image", value: null, isUpload: true },
// ];

// const STATUS_FIELD_MAP = {
//     "Company Name": "companyNameStatus",
//     "Business Type": "companyTypeStatus",
//     "Company PAN": "companyPanStatus",
//     "Company GST": "companyGstStatus",
//     "CIN (For Companies)": "cinStatus",
//     "Registered Address": "registeredAddressStatus",
//     "City": "cityStatus",
//     "State": "stateStatus",
//     "Pincode": "pincodeStatus",
//     "Incorporation Certificate": "incorporationCertificateStatus",
//     "GST Certificate": "gstCertificateStatus",
//     "Trade License": "tradeLicenseStatus",
//     "Owner Full Name": "ownerFullNameStatus",
//     "Owner Date of Birth": "ownerDobStatus",
//     "Owner PAN": "ownerPanStatus",
//     "Owner Aadhaar": "ownerAadhaarStatus",
//     "Owner Mobile": "ownerMobileStatus",
//     "Owner Email": "ownerEmailStatus",
//     "Owner Address": "ownerAddressStatus",
//     "Owner PAN Document": "ownerPanDocumentStatus",
//     "Owner Aadhaar Document": "ownerAadhaarDocumentStatus",
//     "Owner Image": "ownerSelfieStatus",
// };

// // Company Type options - Updated to match API enum values
// const companyTypeOptions = [
//     "PROPRIETORSHIP",
//     "PARTNERSHIP",
//     "LLP",
//     "PRIVATE_LIMITED"
// ];

// // Display map for user-friendly names
// const companyTypeDisplayMap = {
//     "PROPRIETORSHIP": "Proprietorship",
//     "PARTNERSHIP": "Partnership",
//     "LLP": "Limited Liability Partnership (LLP)",
//     "PRIVATE_LIMITED": "Private Limited"
// };

// // Safe date conversion utility
// const safeDateToISOString = (dateString) => {
//     if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "";

//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) return "";

//     return date.toISOString().split("T")[0];
// };

// // Safe date display utility
// const safeDateDisplay = (dateString) => {
//     if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "N/A";

//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) return "N/A";

//     return date.toLocaleDateString();
// };

// // Add this function to check if a field has valid data
// const hasValidData = (row, companyVerificationData) => {
//     if (!row || !companyVerificationData) return false;

//     const field = row.key;
//     const value = row.value;

//     // Check if the value exists and is not empty/"N/A"
//     if (typeof value === 'string') {
//         return value && value !== "N/A" && value.trim() !== "";
//     }

//     if (typeof value === 'object') {
//         // For objects, check if any property has valid data
//         return Object.values(value).some(val =>
//             val && val !== "N/A" && val.toString().trim() !== ""
//         );
//     }

//     return false;
// };

// // Update your isFieldVerified function to check both status AND data presence
// const isFieldVerified = (rowKey, rowValue, companyVerificationData) => {
//     const normalisedKey = rowKey.trim();
//     const statusField = STATUS_FIELD_MAP[normalisedKey];

//     if (!statusField || !companyVerificationData) return false;

//     // If status is explicitly true, it's verified
//     if (companyVerificationData[statusField] === true) return true;

//     // If status is null/undefined but field has valid data, consider it verified
//     if ((companyVerificationData[statusField] === null || companyVerificationData[statusField] === undefined) &&
//         hasValidData({ key: rowKey, value: rowValue }, companyVerificationData)) {
//         return true;
//     }

//     return false;
// };

// // Update your isFieldRejected function similarly
// const isFieldRejected = (rowKey, companyVerificationData) => {
//     const normalisedKey = rowKey.trim();
//     const statusField = STATUS_FIELD_MAP[normalisedKey];

//     if (!statusField || !companyVerificationData) return false;

//     // Only return true if explicitly rejected (false)
//     return companyVerificationData[statusField] === false;
// };

// // UPDATED transformApiData function - Better status handling
// const transformApiData = (data) => {
//     if (!Array.isArray(data)) return [];

//     return data.map(item => ({
//         // ✅ IDs
//         id: item.id || item.userId,
//         userId: item.userId || item.id,

//         // ✅ NAME (FIXED)
//         vendorName:
//             item.userName ||
//             item.vendorName ||
//             item.name ||
//             item.fullName ||
//             item.user?.name ||
//             item.businessName ||
//             item.companyName ||
//             "—",

//         // ✅ EMAIL (FIXED)
//         email:
//             item.email ||
//             item.emailId ||
//             item.user?.email ||
//             "—",

//         // ✅ MOBILE
//         mobileNumber:
//             item.mobileNumber ||
//             item.phone ||
//             item.user?.mobile ||
//             "—",

//         // ✅ COMPANY NAME FIELD ADDED
//         companyName:
//             item.companyName ||
//             item.businessName ||
//             "—",

//         category:
//             item.category ||
//             item.businessType ||
//             "Professional",

//         // ✅ UPDATED STATUS FIELD - Try multiple fields
//         status:
//             item.verificationStatus ||
//             item.companyVerificationStatus ||
//             item.status ||
//             item.user?.verificationStatus ||
//             "PENDING", // Default to PENDING instead of "—"

//         // ✅ USER TYPE (VERY IMPORTANT)
//         userType:
//             item.userType ||
//             item.user?.userType ||
//             item.role ||
//             "PROFESSIONAL",

//         // keep everything else
//         ...item
//     }));
// };

// // Function to transform company verification API data
// const transformCompanyVerificationData = (data) => {
//     if (!data) return null;

//     return {
//         // IDs
//         id: data.id,
//         userId: data.userId,

//         // Company Details
//         companyName: data.companyName || "N/A",
//         companyType: data.businessType || data.companyType || "N/A",
//         businessType: data.businessType || data.companyType || "N/A", // Add this line
//         companyPan: data.companyPan || "N/A",
//         companyPanDocument: data.companyPanDocument || null,
//         companyGst: data.gstin || data.companyGst || "N/A",
//         cin: data.cin || "N/A",
//         registeredAddress: data.registeredAddress || "N/A",
//         city: data.city || "N/A",
//         state: data.state || "N/A",
//         pincode: data.pincode || "N/A",
//         incorporationCertificate: data.incorporationCertificate || null,
//         gstCertificate: data.gstCertificate || null,
//         tradeLicense: data.tradeLicense || null,

//         // Owner Details
//         ownerFullName: data.ownerFullName || "N/A",
//         ownerDob: data.ownerDob || "N/A",
//         ownerPan: data.ownerPan || "N/A",
//         ownerAadhaar: data.ownerAadhaar || "N/A",
//         ownerMobile: data.ownerMobile || "N/A",
//         ownerEmail: data.ownerEmail || "N/A",
//         ownerAddress: data.ownerAddress || "N/A",
//         ownerPanDocument: data.ownerPanDocument || null,
//         ownerAadhaarDocument: data.ownerAadhaarDocument || null,
//         ownerSelfie: data.ownerSelfie || null,

//         // Status
//         verificationStatus: data.verificationStatus || "PENDING",
//         rejectionReason: data.rejectionReason || null,
//         submittedAt: data.submittedAt || null,
//         verifiedAt: data.verifiedAt || null,

//         // Original data
//         ...data
//     };
// };

// // API Service functions
// const apiService = {
//     getAuthHeaders: () => {
//         const token = localStorage.getItem("authToken");
//         return {
//             headers: {
//                 Authorization: `Bearer ${token}`,
//                 "Content-Type": "application/json"
//             }
//         };
//     },

//     getFormDataHeaders: () => {
//         const token = localStorage.getItem("authToken");
//         return {
//             headers: {
//                 Authorization: `Bearer ${token}`,
//                 "Content-Type": "multipart/form-data"
//             }
//         };
//     },

//     // Fetch all users
//     fetchAllUsers: async () => {
//         const response = await axios.get(API_ENDPOINTS.GET_ALL_USERS, apiService.getAuthHeaders());
//         return response.data;
//     },

//     // Fetch company verification details - using the new endpoint you mentioned
//     fetchCompanyVerification: async (userId) => {
//         try {
//             const response = await axios.get(
//                 API_ENDPOINTS.GET_USER_COMPANY_VERIFICATION(userId),
//                 apiService.getAuthHeaders()
//             );
//             return response.data;
//         } catch (error) {
//             console.warn(`New endpoint failed, trying old endpoint: ${error.message}`);
//             // Fallback to old endpoint if new one fails
//             const fallbackResponse = await axios.get(
//                 API_ENDPOINTS.COMPANY_VERIFICATION(userId),
//                 apiService.getAuthHeaders()
//             );
//             return fallbackResponse.data;
//         }
//     },

//     // NEW: Fetch verification status for all professional users
//     fetchAllVerificationStatuses: async (userIds) => {
//         const token = localStorage.getItem("authToken");
//         if (!token) return {};

//         const statusPromises = userIds.map(async (userId) => {
//             try {
//                 const response = await axios.get(
//                     API_ENDPOINTS.GET_USER_COMPANY_VERIFICATION(userId),
//                     { headers: { Authorization: `Bearer ${token}` } }
//                 );
//                 // Check if response has valid data
//                 if (response.data && response.data.verificationStatus) {
//                     return { userId, status: response.data.verificationStatus };
//                 }
//                 return { userId, status: "PENDING" };
//             } catch (error) {
//                 // Check if it's a 404 error (not found)
//                 if (error.response?.status === 404) {
//                     return { userId, status: "PENDING" };
//                 }
//                 // For other errors, try the old endpoint as fallback
//                 try {
//                     const fallbackResponse = await axios.get(
//                         API_ENDPOINTS.COMPANY_VERIFICATION(userId),
//                         { headers: { Authorization: `Bearer ${token}` } }
//                     );
//                     if (fallbackResponse.data && fallbackResponse.data.verificationStatus) {
//                         return { userId, status: fallbackResponse.data.verificationStatus };
//                     }
//                     return { userId, status: "PENDING" };
//                 } catch (fallbackError) {
//                     return { userId, status: "PENDING" };
//                 }
//             }
//         });

//         const results = await Promise.all(statusPromises);
//         const statusMap = {};
//         results.forEach(result => {
//             statusMap[result.userId] = result.status;
//         });
//         return statusMap;
//     },

//     // Update company verification
//     updateCompanyVerification: async (userId, formData) => {
//         const response = await axios.put(
//             API_ENDPOINTS.COMPANY_VERIFICATION(userId),
//             formData,
//             apiService.getFormDataHeaders()
//         );
//         return response.data;
//     },

//     // Approve verification (old endpoint)
//     approveVerification: async (userId, data) => {
//         const response = await axios.put(
//             API_ENDPOINTS.COMPANY_VERIFICATION_APPROVE(userId),
//             data,
//             apiService.getAuthHeaders()
//         );
//         return response.data;
//     },

//     // Reject verification (old endpoint)
//     rejectVerification: async (userId, data) => {
//         const response = await axios.put(
//             API_ENDPOINTS.COMPANY_VERIFICATION_REJECT(userId),
//             data,
//             apiService.getAuthHeaders()
//         );
//         return response.data;
//     },

//     // Update verification status (new endpoint)
//     updateVerificationStatus: async (verificationId, data) => {
//         const response = await axios.put(
//             API_ENDPOINTS.UPDATE_VERIFICATION_STATUS(verificationId),
//             data,
//             apiService.getAuthHeaders()
//         );
//         return response.data;
//     }
// };

// /* ---------------- component ---------------- */
// const ProfessionalUser = () => {
//     /* -------- list‑screen state -------- */
//     const [rolesData, setRolesData] = useState([]);
//     const [statusFilter, setStatusFilter] = useState("");
//     const [filteredData, setFilteredData] = useState([]);
//     const [verificationStatuses, setVerificationStatuses] = useState({}); // Store verification statuses
//     const { showLoader, hideLoader } = useLoader();

//     /* -------- detail‑screen state -------- */
//     const [selectedClient, setSelectedClient] = useState(null);
//     const [companyVerificationData, setCompanyVerificationData] = useState(null);
//     const [loading, setLoading] = useState(false);

//     const [rows, setRows] = useState(getDefaultClientDetailsRows());
//     const [verifiedRows, setVerifiedRows] = useState([]);
//     const [rejectedRows, setRejectedRows] = useState([]);
//     const [isApproved, setIsApproved] = useState(false);
//     const [imageLoadErrors, setImageLoadErrors] = useState(new Set());

//     const fileInputRef = useRef(null);
//     const [vendorData, setVendorData] = useState({});
//     const [rowId, setRowId] = useState(null);

//     // State for reject modal/dropdown
//     const [showRejectDropdown, setShowRejectDropdown] = useState(false);
//     const [rejectionDescription, setRejectionDescription] = useState("");

//     // Add loading states for approve and reject
//     const [isApproving, setIsApproving] = useState(false);
//     const [isRejecting, setIsRejecting] = useState(false);

//     // Simple image error handler
//     const handleImageError = (imageUrl, fieldName, index) => {
//         const errorKey = `${fieldName}-${index}`;
//         setImageLoadErrors(prev => new Set([...prev, errorKey]));
//     };

//     const handleImageLoad = (imageUrl, fieldName, index) => {
//         const errorKey = `${fieldName}-${index}`;
//         setImageLoadErrors(prev => {
//             const newSet = new Set(prev);
//             newSet.delete(errorKey);
//             return newSet;
//         });
//     };

//     const isImageFailed = (fieldName, index) => {
//         return imageLoadErrors.has(`${fieldName}-${index}`);
//     };

//     // Fetch company verification details
//     const fetchCompanyVerificationDetails = async (userId) => {
//         if (!userId) return;
//         setLoading(true);

//         try {
//             const data = await apiService.fetchCompanyVerification(userId);
//             console.log("✅ ADMIN FETCH DATA:", data);
//             setCompanyVerificationData(transformCompanyVerificationData(data));
//         } catch (err) {
//             console.error("❌ Fetch error:", err);
//             if (err.response?.status === 404) {
//                 setCompanyVerificationData(null);
//             } else {
//                 // alert(`Failed to fetch verification details: ${err.message}`);
//             }
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Fetch verification status for all users
//     const fetchVerificationStatuses = async (users) => {
//         const userIds = users.map(user => user.userId || user.id);
//         try {
//             const statusMap = await apiService.fetchAllVerificationStatuses(userIds);
//             setVerificationStatuses(statusMap);

//             // Update the rolesData with verification statuses
//             setRolesData(prev => prev.map(user => ({
//                 ...user,
//                 verificationStatus: statusMap[user.userId] || user.verificationStatus || user.status || "PENDING"
//             })));
//         } catch (error) {
//             console.error("Error fetching verification statuses:", error);
//         }
//     };

//     const handleSaveRow = async (rowIndex) => {
//         const token = localStorage.getItem("authToken");
//         if (!token) return alert("Login required");

//         const verificationId = companyVerificationData?.id;
//         if (!verificationId) {
//             alert("Company verification ID missing");
//             return;
//         }

//         const row = rows[rowIndex];
//         const imageField = getImageFieldName(row.key);

//         // ✅ TEXT FIELD MAP
//         const TEXT_FIELD_MAP = {
//             "Company Name": "companyName",
//             "Business Type": "businessType",
//             "Company PAN": "companyPan",
//             "Company GST": "gstin",
//             "CIN (For Companies)": "cin",
//             "Registered Address": "registeredAddress",
//             "City": "city",
//             "State": "state",
//             "Pincode": "pincode",
//             "Owner Full Name": "ownerFullName",
//             "Owner Date of Birth": "ownerDob",
//             "Owner PAN": "ownerPan",
//             "Owner Aadhaar": "ownerAadhaar",
//             "Owner Mobile": "ownerMobile",
//             "Owner Email": "ownerEmail",
//             "Owner Address": "ownerAddress",
//         };

//         const textField = TEXT_FIELD_MAP[row.key];

//         // 🚫 NOTHING TO SAVE
//         if (!imageField && !textField) {
//             alert("This field cannot be updated");
//             return;
//         }

//         const formData = new FormData();

//         // ✅ TEXT UPDATE
//         if (textField) {
//             if (!row.value || row.value === "N/A") {
//                 alert("Please enter a value");
//                 return;
//             }

//             formData.append(
//                 "companyData",
//                 new Blob(
//                     [JSON.stringify({ [textField]: row.value })],
//                     { type: "application/json" }
//                 )
//             );
//         }

//         // ✅ IMAGE UPDATE (ONLY ONE FILE)
//         if (imageField) {
//             const image = row.images?.[row.images.length - 1];
//             if (!image?.file || !(image.file instanceof File)) {
//                 alert("Please select a valid image");
//                 return;
//             }

//             // ✅ BACKEND REQUIRES companyData EVEN FOR IMAGE UPDATES
//             formData.append(
//                 "companyData",
//                 new Blob([JSON.stringify({})], { type: "application/json" })
//             );

//             formData.append(imageField, image.file);
//         }

//         try {
//             await axios.put(
//                 `${API_BASE_URL}/company/verification/${verificationId}`,
//                 formData,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`
//                         // ❌ DO NOT set Content-Type
//                     }
//                 }
//             );

//             // refresh
//             await fetchCompanyVerificationDetails(selectedClient.userId);

//             setRows(prev =>
//                 prev.map((r, i) =>
//                     i === rowIndex ? { ...r, isEditing: false } : r
//                 )
//             );

//         } catch (err) {
//             console.error("❌ Update failed", err);
//             alert(
//                 err.response?.data?.error ||
//                 err.response?.data?.message ||
//                 "Update failed"
//             );
//         }
//     };

//     const fetchProfessionalUsers = async () => {
//         showLoader();

//         try {
//             const data = await apiService.fetchAllUsers();
//             const professionalUsers = transformApiData(data).filter(
//                 u => u.userType?.toUpperCase() === "PROFESSIONAL"
//             );

//             setRolesData(professionalUsers);

//             // Fetch verification statuses for all users
//             await fetchVerificationStatuses(professionalUsers);

//             if (professionalUsers[0]?.userId) {
//                 fetchCompanyVerificationDetails(professionalUsers[0].userId);
//             }

//         } catch (err) {
//             console.error("Failed to fetch users:", err);
//             alert("Failed to fetch users: " + err.message);
//         } finally {
//             hideLoader();
//         }
//     };

//     const getImageFieldName = (key) => {
//         const map = {
//             "Incorporation Certificate": "incorporationCertificate",
//             "GST Certificate": "gstCertificate",
//             "Trade License": "tradeLicense",
//             "Owner PAN Document": "ownerPanDocument",
//             "Owner Aadhaar Document": "ownerAadhaarDocument",
//             "Owner Image": "ownerSelfie",
//             "Company PAN Document": "companyPanDocument",
//         };
//         return map[key] || null;
//     };

//     // Fetch professional users
//     useEffect(() => {
//         fetchProfessionalUsers();
//     }, []);

//     useEffect(() => {
//         let data = rolesData;
//         if (statusFilter) {
//             if (statusFilter === "ALL") {
//                 // Show all
//             } else {
//                 data = data.filter((i) => 
//                     i.verificationStatus === statusFilter || 
//                     i.status === statusFilter
//                 );
//             }
//         }
//         setFilteredData(data);
//     }, [statusFilter, rolesData]);

//     useEffect(() => {
//         if (!selectedClient) {
//             setRows(getDefaultClientDetailsRows());
//             setVerifiedRows([]);
//             setRejectedRows([]);
//             setIsApproved(false);
//             setImageLoadErrors(new Set());
//             return;
//         }

//         const merged = { ...selectedClient, ...(companyVerificationData || {}) };

//         // Image mapping based on API response field names
//         const imageMap = {
//             "Incorporation Certificate": [merged.incorporationCertificate]
//                 .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//             "GST Certificate": [merged.gstCertificate]
//                 .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//             "Trade License": [merged.tradeLicense]
//                 .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//             "Owner PAN Document": [merged.ownerPanDocument]
//                 .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//             "Owner Aadhaar Document": [merged.ownerAadhaarDocument]
//                 .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//             "Owner Image": [merged.ownerSelfie]
//                 .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//             "Company PAN Document": [merged.companyPanDocument]
//                 .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//         };

//         const newRows = [
//             { key: "Company Name", value: merged.companyName || "N/A" },
//             { key: "Business Type", value: merged.businessType || merged.companyType || "N/A" },
//             { key: "Company PAN", value: merged.companyPan || "N/A" },
//             { key: "Company PAN Document", value: "Company PAN Document" },
//             { key: "Company GST", value: merged.companyGst || merged.gstin || "N/A" },
//             { key: "CIN (For Companies)", value: merged.cin || "N/A" },
//             { key: "Registered Address", value: merged.registeredAddress || "N/A" },
//             { key: "City", value: merged.city || "N/A" },
//             { key: "State", value: merged.state || "N/A" },
//             { key: "Pincode", value: merged.pincode || "N/A" },
//             { key: "Incorporation Certificate", value: "Incorporation Certificate" },
//             { key: "GST Certificate", value: "GST Certificate" },
//             { key: "Trade License", value: "Trade License" },
//             { key: "Owner Full Name", value: merged.ownerFullName || "N/A" },
//             { key: "Owner Date of Birth", value: merged.ownerDob || "N/A" },
//             { key: "Owner PAN", value: merged.ownerPan || "N/A" },
//             { key: "Owner Aadhaar", value: merged.ownerAadhaar || "N/A" },
//             { key: "Owner Mobile", value: merged.ownerMobile || "N/A" },
//             { key: "Owner Email", value: merged.ownerEmail || "N/A" },
//             { key: "Owner Address", value: merged.ownerAddress || "N/A" },
//             { key: "Owner PAN Document", value: "Owner PAN Document" },
//             { key: "Owner Aadhaar Document", value: "Owner Aadhaar Document" },
//             { key: "Owner Image", value: "Owner Image" },
//         ];

//         const updatedRows = newRows.map((row) => ({
//             ...row,
//             images: imageMap[row.key] || [],
//         }));

//         setRows(updatedRows.map((r) => ({ ...r, isEditing: false })));
//         setVerifiedRows([]);
//         setRejectedRows([]);
//         setIsApproved(false);
//         setImageLoadErrors(new Set());
//     }, [selectedClient, companyVerificationData]);

//     const handleViewClick = (client) => {
//         console.log("👁️ VIEW CLICKED FOR CLIENT:", client);
//         setSelectedClient(client);
//         const userId = client?.userId;
//         console.log("🔍 FETCHING COMPANY VERIFICATION DETAILS FOR USER ID:", userId);
//         fetchCompanyVerificationDetails(userId);
//     };

//     const handleReject = async (i) => {
//         const normalisedKey = rows[i].key.trim();
//         const statusField = STATUS_FIELD_MAP[normalisedKey];

//         if (!statusField) {
//             setRejectedRows(prev => (prev.includes(i) ? prev : [...prev, i]));
//             return;
//         }

//         const userId = selectedClient?.userId;
//         if (!userId) return alert("User ID is missing – cannot update.");

//         try {
//             const data = {
//                 verificationStatus: "REJECTED",
//                 rejectionReason: "Field rejected: " + rows[i].key
//             };

//             // Try the new endpoint first
//             const verificationId = companyVerificationData?.id;
//             if (verificationId) {
//                 await apiService.updateVerificationStatus(verificationId, data);
//             } else {
//                 // Fallback to old endpoint
//                 await apiService.rejectVerification(userId, data);
//             }

//             alert("Company verification rejected successfully!");
//             fetchCompanyVerificationDetails(userId);
//         } catch (err) {
//             console.error("❌ Reject error:", err);
//             alert(`Failed to reject: ${err.message}`);
//         }
//     };

//     const handleVerifyy = async (i) => {
//         const userId = selectedClient?.userId;
//         if (!userId) return alert("User ID is missing");

//         try {
//             const data = {
//                 verificationStatus: "VERIFIED",
//                 rejectionReason: ""
//             };

//             const verificationId = companyVerificationData?.id;
//             if (verificationId) {
//                 await apiService.updateVerificationStatus(verificationId, data);
//             } else {
//                 await apiService.approveVerification(userId, data);
//             }

//             await fetchCompanyVerificationDetails(userId);
//             alert("Company verification verified successfully!");
//         } catch (err) {
//             console.error("❌ Verify error:", err.response?.data || err.message);
//             alert("Failed to verify company");
//         }
//     };

//     // New function to handle approve all
//     const handleApproveAll = async () => {
//         const userId = selectedClient?.userId;
//         if (!userId) return alert("User ID is missing");

//         setIsApproving(true); // Start loader

//         try {
//             const data = {
//                 verificationStatus: "VERIFIED",
//                 rejectionReason: ""
//             };

//             const verificationId = companyVerificationData?.id;
//             if (verificationId) {
//                 await apiService.updateVerificationStatus(verificationId, data);
//             } else {
//                 await apiService.approveVerification(userId, data);
//             }

//             await fetchCompanyVerificationDetails(userId);
//             alert("Company verified successfully!");
//         } catch (err) {
//             console.error("❌ Approve error:", err.response?.data || err.message);
//             alert("Failed to approve company");
//         } finally {
//             setIsApproving(false); // Stop loader
//         }
//     };

//     // New function to handle reject all with reason
//     const handleRejectAll = async () => {
//         if (!rejectionDescription.trim()) {
//             alert("Please enter a rejection reason");
//             return;
//         }

//         const userId = selectedClient?.userId;
//         if (!userId) return alert("User ID is missing");

//         setIsRejecting(true); // Start loader

//         try {
//             const data = {
//                 verificationStatus: "REJECTED",
//                 rejectionReason: rejectionDescription
//             };

//             // Try the new endpoint first
//             const verificationId = companyVerificationData?.id;
//             if (verificationId) {
//                 await apiService.updateVerificationStatus(verificationId, data);
//             } else {
//                 // Fallback to old endpoint
//                 await apiService.rejectVerification(userId, data);
//             }

//             setShowRejectDropdown(false);
//             setRejectionDescription("");
//             await fetchCompanyVerificationDetails(userId);
//             alert("Company verification rejected successfully!");
//         } catch (err) {
//             console.error("❌ Reject error:", err);
//             alert(`Failed to reject: ${err.message}`);
//         } finally {
//             setIsRejecting(false); // Stop loader
//         }
//     };

//     const handleBackClick = () => setSelectedClient(null);

//     const handleFileChange = (e, index) => {
//         const fileName = e.target.files[0]?.name || "";
//         const updated = [...rows];
//         updated[index].value = fileName;
//         setRows(updated);
//     };

//     // Clean Image Display Component with "-" for missing images
//     const ImageDisplay = ({ images, fieldName }) => {
//         if (!images || images.length === 0) {
//             return (
//                 <div className="text-center">
//                     <span style={{ fontSize: "18px", color: "#6c757d" }}>-</span>
//                 </div>
//             );
//         }

//         return (
//             <div className="d-flex justify-content-center gap-2 flex-wrap">
//                 {images.map((img, idx) => {
//                     const imageUrl = typeof img === 'string' ? img : img.url;
//                     const hasFailed = isImageFailed(fieldName, idx);

//                     if (hasFailed || !imageUrl) {
//                         return (
//                             <div key={idx} className="text-center">
//                                 <span style={{ fontSize: "18px", color: "#6c757d" }}>-</span>
//                             </div>
//                         );
//                     }

//                     // For selfie, show larger image
//                     const isSelfie = fieldName === "Owner Image";

//                     return (
//                         <div key={idx} className="text-center position-relative">
//                             <img
//                                 src={imageUrl}
//                                 alt={`${fieldName}-${idx}`}
//                                 style={{
//                                     width: isSelfie ? "80px" : "60px",
//                                     height: isSelfie ? "80px" : "60px",
//                                     borderRadius: "6px",
//                                     objectFit: "cover",
//                                     border: "1px solid #dee2e6",
//                                 }}
//                                 onError={() => handleImageError(imageUrl, fieldName, idx)}
//                                 onLoad={() => handleImageLoad(imageUrl, fieldName, idx)}
//                             />
//                             {isSelfie && (
//                                 <div className="mt-1 small text-muted">Image</div>
//                             )}
//                         </div>
//                     );
//                 })}
//             </div>
//         );
//     };

//     // Function to get badge color based on status
//     const getStatusBadgeColor = (status) => {
//         if (!status) return "bg-secondary";
//         if (status === "VERIFIED" || status === "APPROVED") return "bg-success";
//         if (status === "REJECTED") return "bg-danger";
//         if (status === "PENDING") return "bg-warning";
//         return "bg-secondary";
//     };

//     // Function to get display text for status
//     const getStatusDisplayText = (status) => {
//         if (!status) return "Pending";
//         return status;
//     };

//     return (
//         <div className="container-fluid">
//             <div className="row">
//                 <div className="col-lg-12" style={{ marginTop: "10px" }}>
//                     <div className="client" style={{ overflowY: "auto", height: "500px" }}>
//                         {!selectedClient ? (
//                             <>
//                                 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
//                                     <div></div>
//                                     <div className="pe-3">
//                                         {/* Status Filter Dropdown - REMOVED NOT_SUBMITTED option */}
//                                         <select 
//                                             className="form-select form-select-sm" 
//                                             style={{ width: "200px" }}
//                                             value={statusFilter}
//                                             onChange={(e) => setStatusFilter(e.target.value)}
//                                         >
//                                             <option value="">All Statuses</option>
//                                             <option value="VERIFIED">Verified</option>
//                                             <option value="APPROVED">Approved</option>
//                                             <option value="PENDING">Pending</option>
//                                             <option value="REJECTED">Rejected</option>
//                                             {/* NOT_SUBMITTED option removed as requested */}
//                                         </select>
//                                     </div>
//                                 </div>

//                                 <div className="sed pe-3">
//                                     <table style={tableStyle} className="table table-striped">
//                                         <thead>
//                                             <tr>
//                                                 <th style={thStyle}>S.NO</th>
//                                                 <th style={thStyle}>Name</th>
//                                                 <th style={thStyle}>User ID</th>
//                                                 <th style={thStyle}>Email</th>
//                                                 <th style={thStyle}>Company Name</th>
//                                                 <th style={thStyle}>Phone Number</th>
//                                                 <th style={thStyle}>User Type</th>
//                                                 <th style={thStyle}>Verification Status</th>
//                                                 <th style={thStyle}>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {filteredData.length ? (
//                                                 filteredData.map((c, idx) => {
//                                                     // Get status from verificationStatus or status field
//                                                     const userStatus = c.verificationStatus || c.status || "PENDING";
//                                                     return (
//                                                         <tr key={c.id || idx}>
//                                                             <td style={thTdStyle}>{idx + 1}</td>
//                                                             <td style={thTdStyle}>{c?.vendorName || "—"}</td>
//                                                             <td style={thTdStyle}>{c?.userId || c?.id || "—"}</td>
//                                                             <td style={thTdStyle}>{c?.email || "—"}</td>
//                                                             <td style={thTdStyle}>{c?.companyName || "—"}</td>
//                                                             <td style={thTdStyle}>{c?.mobileNumber || "—"}</td>
//                                                             <td style={thTdStyle}>{c?.userType || "—"}</td>
//                                                             <td style={thTdStyle}>
//                                                                 <span className={`badge ${getStatusBadgeColor(userStatus)}`}>
//                                                                     {getStatusDisplayText(userStatus)}
//                                                                 </span>
//                                                             </td>
//                                                             <td style={thTdStyle}>
//                                                                 <button
//                                                                     style={{ ...buttonStyle, color: "rgb(230 109 51)", fontWeight: "bold" }}
//                                                                     onClick={() => handleViewClick(c)}
//                                                                 >
//                                                                     View
//                                                                 </button>
//                                                             </td>
//                                                         </tr>
//                                                     );
//                                                 })
//                                             ) : (
//                                                 <tr>
//                                                     <td style={thTdStyle} colSpan={9}>
//                                                         No data available
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </>
//                         ) : (
//                             <div className="mt-4 rounded-3 shadow-sm">
//                                 <div className="d-flex align-items-center mb-4">
//                                     <button
//                                         onClick={handleBackClick}
//                                         className="btn fw-bold px-4 py-2"
//                                         style={{ backgroundColor: "rgb(230 109 51)", color: "#fff" }}
//                                     >
//                                         Back to List
//                                     </button>
//                                     {companyVerificationData && (
//                                         <div className="ms-3">

//                                         </div>
//                                     )}
//                                 </div>

//                                 {loading && (
//                                     <div className="text-center my-4">
//                                         <span className="spinner-border text-primary" />
//                                     </div>
//                                 )}

//                                 {!loading && (
//                                     <>
//                                         <div className="register mt-4">
//                                             <div className="registertable bo2">
//                                                 <table className="table table-bordered table-striped align-middle mt-4 w-100">
//                                                     <thead>
//                                                         <tr>
//                                                             <th style={detailThStyle}>Field</th>
//                                                             <th style={detailThStyle}>Value</th>
//                                                             <th style={detailThStyle}>Image</th>
//                                                             <th style={detailThStyle}>Status</th>
//                                                         </tr>
//                                                     </thead>

//                                                     <tbody>
//                                                         {rows.map((r, i) => {
//                                                             const isEditing = r.isEditing || false;

//                                                             const handleInputChange = (field, value) => {
//                                                                 setRows((prevRows) =>
//                                                                     prevRows.map((row, idx) =>
//                                                                         idx === i
//                                                                             ? {
//                                                                                 ...row,
//                                                                                 value:
//                                                                                     typeof row.value === "object"
//                                                                                         ? { ...row.value, [field]: value }
//                                                                                         : value,
//                                                                             }
//                                                                             : row
//                                                                     )
//                                                                 );
//                                                             };

//                                                             // Handle Company Type selection
//                                                             const handleCompanyTypeChange = (selectedValue) => {
//                                                                 setRows((prevRows) =>
//                                                                     prevRows.map((row, idx) =>
//                                                                         idx === i
//                                                                             ? {
//                                                                                 ...row,
//                                                                                 value: selectedValue,
//                                                                             }
//                                                                             : row
//                                                                     )
//                                                                 );
//                                                             };

//                                                             const handleImageChange = (e) => {
//                                                                 const files = Array.from(e.target.files);
//                                                                 const newImages = files.map((file) => ({
//                                                                     url: URL.createObjectURL(file),
//                                                                     file
//                                                                 }));

//                                                                 setRows(prev =>
//                                                                     prev.map((row, idx) =>
//                                                                         idx === i
//                                                                             ? {
//                                                                                 ...row,
//                                                                                 images: [...(row.images || []), ...newImages]
//                                                                             }
//                                                                             : row
//                                                                     )
//                                                                 );
//                                                             };

//                                                             return (
//                                                                 <tr key={r.key || i}>
//                                                                     <td className="fw-bold text-center align-middle">{r.key}</td>

//                                                                     <td className="text-start align-middle">
//                                                                         {r.key === "Business Type" ? (
//                                                                             isEditing ? (
//                                                                                 <select
//                                                                                     value={r.value || ""}
//                                                                                     onChange={(e) => handleCompanyTypeChange(e.target.value)}
//                                                                                     className="form-select w-75"
//                                                                                 >
//                                                                                     <option value="">Select Business Type</option>
//                                                                                     {companyTypeOptions.map((option) => (
//                                                                                         <option key={option} value={option}>
//                                                                                             {companyTypeDisplayMap[option] || option}
//                                                                                         </option>
//                                                                                     ))}
//                                                                                 </select>
//                                                                             ) : (
//                                                                                 companyTypeDisplayMap[r.value] || r.value || "N/A"
//                                                                             )
//                                                                         ) : r.key === "Owner Date of Birth" ? (
//                                                                             isEditing ? (
//                                                                                 <input
//                                                                                     type="date"
//                                                                                     value={safeDateToISOString(r.value)}
//                                                                                     onChange={(e) => handleInputChange("value", e.target.value)}
//                                                                                     className="form-control d-inline-block w-75"
//                                                                                 />
//                                                                             ) : (
//                                                                                 safeDateDisplay(r.value)
//                                                                             )
//                                                                         ) : r.key === "Incorporation Certificate" ? (
//                                                                             "Incorporation Certificate"
//                                                                         ) : r.key === "GST Certificate" ? (
//                                                                             "GST Certificate"
//                                                                         ) : r.key === "Trade License" ? (
//                                                                             "Trade License"
//                                                                         ) : r.key === "Owner PAN Document" ? (
//                                                                             "Owner PAN Document"
//                                                                         ) : r.key === "Owner Aadhaar Document" ? (
//                                                                             "Owner Aadhaar Document"
//                                                                         ) : r.key === "Owner Image" ? (
//                                                                             "Owner Image"
//                                                                         ) : r.key === "Company PAN Document" ? (
//                                                                             "Company PAN Document"
//                                                                         ) : (
//                                                                             isEditing ? (
//                                                                                 <input
//                                                                                     type="text"
//                                                                                     value={r.value || ""}
//                                                                                     onChange={(e) => handleInputChange("value", e.target.value)}
//                                                                                     className="form-control d-inline-block w-75"
//                                                                                 />
//                                                                             ) : (
//                                                                                 r.value || "N/A"
//                                                                             )
//                                                                         )}
//                                                                     </td>

//                                                                     <td className="text-center align-middle">
//                                                                         {isImageField(r.key) ? (
//                                                                             <>
//                                                                                 {isEditing && (
//                                                                                     <input
//                                                                                         type="file"
//                                                                                         multiple={r.key === "Owner Aadhaar Document"}
//                                                                                         accept="image/*,.pdf"
//                                                                                         onChange={handleImageChange}
//                                                                                         className="form-control mb-2"
//                                                                                     />
//                                                                                 )}
//                                                                                 <ImageDisplay images={r.images} fieldName={r.key} />
//                                                                             </>
//                                                                         ) : (
//                                                                             <span style={{ fontSize: "18px", color: "#6c757d" }}>-</span>
//                                                                         )}
//                                                                     </td>

//                                                                     <td className="text-center align-middle">
//                                                                         {isEditing ? (
//                                                                             <>
//                                                                                 <button
//                                                                                     className="btn btn-sm btn-success me-2"
//                                                                                     style={{ minWidth: 80 }}
//                                                                                     onClick={() => handleSaveRow(i)}
//                                                                                 >
//                                                                                     Save
//                                                                                 </button>
//                                                                                 <button
//                                                                                     className="btn btn-sm btn-secondary"
//                                                                                     style={{ minWidth: 80 }}
//                                                                                     onClick={() =>
//                                                                                         setRows((prev) =>
//                                                                                             prev.map((row, idx) =>
//                                                                                                 idx === i ? { ...row, isEditing: false } : row
//                                                                                             )
//                                                                                         )
//                                                                                     }
//                                                                                 >
//                                                                                     Cancel
//                                                                                 </button>
//                                                                             </>
//                                                                         ) : (
//                                                                             <div style={{ display: "flex", gap: "10px" }}>
//                                                                                 <button
//                                                                                     className="btn btn-sm btn-primary"
//                                                                                     style={{ minWidth: 80 }}
//                                                                                     onClick={() =>
//                                                                                         setRows((prev) =>
//                                                                                             prev.map((row, idx) =>
//                                                                                                 idx === i ? { ...row, isEditing: true } : row
//                                                                                             )
//                                                                                         )
//                                                                                     }
//                                                                                 >
//                                                                                     Edit
//                                                                                 </button>
//                                                                             </div>
//                                                                         )}
//                                                                     </td>
//                                                                 </tr>
//                                                             );
//                                                         })}
//                                                     </tbody>
//                                                 </table>
//                                             </div>
//                                         </div>

//                                         {/* Approve and Reject Buttons at Bottom - FIXED LAYOUT */}
//                                         <div className="d-flex justify-content-center gap-3 mt-4 mb-4 p-3 border-top position-relative">
//                                             <div className="d-flex gap-3 align-items-start position-relative">
//                                                 {/* Conditionally render Approve button or Approved status */}
//                                                 {companyVerificationData?.verificationStatus === "VERIFIED" || companyVerificationData?.verificationStatus === "APPROVED" ? (
//                                                     <div className="d-flex align-items-center">
//                                                         <span className="badge bg-success p-2 fs-6">Approved</span>
//                                                     </div>
//                                                 ) : (
//                                                     <button
//                                                         className="btn btn-success px-4 py-2 fw-bold"
//                                                         style={{ minWidth: "120px" }}
//                                                         onClick={handleApproveAll}
//                                                         disabled={isApproving || isRejecting}
//                                                     >
//                                                         {isApproving ? (
//                                                             <>
//                                                                 <span className="spinner-border spinner-border-sm me-2"></span>
//                                                                 Approving...
//                                                             </>
//                                                         ) : (
//                                                             "Approve"
//                                                         )}
//                                                     </button>
//                                                 )}

//                                                 {/* Conditionally render Reject button or nothing */}
//                                                 {companyVerificationData?.verificationStatus !== "VERIFIED" &&
//                                                     companyVerificationData?.verificationStatus !== "APPROVED" && (
//                                                         <div className="position-relative">
//                                                             {showRejectDropdown ? (
//                                                                 <div className="card p-3 shadow-sm" style={{
//                                                                     width: "300px",
//                                                                     position: "absolute",
//                                                                     top: "100%",
//                                                                     left: "0",
//                                                                     marginTop: "0px",
//                                                                     zIndex: 1000
//                                                                 }}>
//                                                                     <div className="mb-3">
//                                                                         <label className="form-label fw-bold">Rejection Reason</label>
//                                                                         <textarea
//                                                                             className="form-control"
//                                                                             rows="3"
//                                                                             placeholder="Enter rejection reason..."
//                                                                             value={rejectionDescription}
//                                                                             onChange={(e) => setRejectionDescription(e.target.value)}
//                                                                             disabled={isApproving || isRejecting}
//                                                                         />
//                                                                     </div>

//                                                                     <div className="d-flex gap-2">
//                                                                         <button
//                                                                             className="btn btn-danger flex-grow-1"
//                                                                             onClick={handleRejectAll}
//                                                                             disabled={!rejectionDescription.trim() || isApproving || isRejecting}
//                                                                         >
//                                                                             {isRejecting ? (
//                                                                                 <>
//                                                                                     <span className="spinner-border spinner-border-sm me-2"></span>
//                                                                                     Rejecting...
//                                                                                 </>
//                                                                             ) : (
//                                                                                 "Confirm Reject"
//                                                                             )}
//                                                                         </button>
//                                                                         <button
//                                                                             className="btn btn-secondary"
//                                                                             onClick={() => {
//                                                                                 setShowRejectDropdown(false);
//                                                                                 setRejectionDescription("");
//                                                                             }}
//                                                                             disabled={isApproving || isRejecting}
//                                                                         >
//                                                                             Cancel
//                                                                         </button>
//                                                                     </div>
//                                                                 </div>
//                                                             ) : (
//                                                                 <button
//                                                                     className="btn btn-danger px-4 py-2 fw-bold"
//                                                                     style={{ minWidth: "120px" }}
//                                                                     onClick={() => setShowRejectDropdown(true)}
//                                                                     disabled={companyVerificationData?.verificationStatus === "REJECTED" || isApproving || isRejecting}
//                                                                 >
//                                                                     {isRejecting ? (
//                                                                         <>
//                                                                             <span className="spinner-border spinner-border-sm me-2"></span>
//                                                                             Rejecting...
//                                                                         </>
//                                                                     ) : (
//                                                                         "Reject"
//                                                                     )}
//                                                                 </button>
//                                                             )}
//                                                         </div>
//                                                     )}
//                                             </div>
//                                         </div>
//                                     </>
//                                 )}
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// const tableStyle = { width: "100%", borderCollapse: "collapse", marginTop: 5 };
// const thTdStyle = { border: "1px solid #ddd", textAlign: "center" };
// const thStyle = { ...thTdStyle, backgroundColor: "rgb(230 109 51)", color: "#fff", fontWeight: "bold", maxWidth: "70px" };
// const buttonStyle = { backgroundColor: "transparent", border: "none", cursor: "pointer" };

// const detailThStyle = {
//     ...thTdStyle,
//     backgroundColor: "rgb(230 109 51)",
//     color: "#fff",
//     fontWeight: 600,
//     padding: "0.75rem",
//     verticalAlign: "middle",
//     border: "1px solid #dee2e6",
//     textAlign: "center"
// };

// export default ProfessionalUser;












// import React, { useState, useEffect, useRef } from "react";
// import axios from "axios";
// import * as XLSX from 'xlsx'; // Import XLSX for Excel export
// import { Link } from "react-router-dom";
// import { useLoader } from '../../../../context/LoaderProvider.jsx';

// // API Base URL - Define it once and reuse
// const API_BASE_URL = "https://backend.maamaas.com/subscription/api";

// const REQUIRED_IMAGE_FIELDS = [
//     "Incorporation Certificate",
//     "GST Certificate",
//     "Trade License",
//     "Owner PAN Document",
//     "Owner Aadhaar Document",
//     "Owner Image",
//     "Company PAN Document"
// ];
// const isImageField = (rowKey) => REQUIRED_IMAGE_FIELDS.includes(rowKey);

// // API Endpoints
// const API_ENDPOINTS = {
//     GET_ALL_USERS: `${API_BASE_URL}/admin/getallusers`,
//     COMPANY_VERIFICATION: (userId) => `${API_BASE_URL}/company/verification/${userId}`,
//     COMPANY_VERIFICATION_APPROVE: (userId) => `${API_BASE_URL}/admin/company/verification/approve/${userId}`,
//     COMPANY_VERIFICATION_REJECT: (userId) => `${API_BASE_URL}/admin/company/verification/reject/${userId}`,
//     GET_USER_COMPANY_VERIFICATION: (userId) => `${API_BASE_URL}/user/company/verification/${userId}`,
//     // Add the new status update endpoint
//     UPDATE_VERIFICATION_STATUS: (verificationId) => `${API_BASE_URL}/company/verification/${verificationId}/status`
// };

// const getDefaultClientDetailsRows = () => [
//     { key: "Company Name", value: "", isUpload: false },
//     { key: "Business Type", value: "", isUpload: false },
//     { key: "Company PAN", value: "", isUpload: false },
//     { key: "Company GST", value: "", isUpload: false },
//     { key: "CIN (For Companies)", value: "", isUpload: false },
//     { key: "Registered Address", value: "", isUpload: false },
//     { key: "City", value: "", isUpload: false },
//     { key: "State", value: "", isUpload: false },
//     { key: "Pincode", value: "", isUpload: false },
//     { key: "Incorporation Certificate", value: null, isUpload: true },
//     { key: "GST Certificate", value: null, isUpload: true },
//     { key: "Trade License", value: null, isUpload: true },
//     { key: "Owner Full Name", value: "", isUpload: false },
//     { key: "Owner Date of Birth", value: "", isUpload: false },
//     { key: "Owner PAN", value: "", isUpload: false },
//     { key: "Owner Aadhaar", value: "", isUpload: false },
//     { key: "Owner Mobile", value: "", isUpload: false },
//     { key: "Owner Email", value: "", isUpload: false },
//     { key: "Owner Address", value: "", isUpload: false },
//     { key: "Owner PAN Document", value: null, isUpload: true },
//     { key: "Owner Aadhaar Document", value: null, isUpload: true },
//     { key: "Owner Image", value: null, isUpload: true },
// ];

// const STATUS_FIELD_MAP = {
//     "Company Name": "companyNameStatus",
//     "Business Type": "companyTypeStatus",
//     "Company PAN": "companyPanStatus",
//     "Company GST": "companyGstStatus",
//     "CIN (For Companies)": "cinStatus",
//     "Registered Address": "registeredAddressStatus",
//     "City": "cityStatus",
//     "State": "stateStatus",
//     "Pincode": "pincodeStatus",
//     "Incorporation Certificate": "incorporationCertificateStatus",
//     "GST Certificate": "gstCertificateStatus",
//     "Trade License": "tradeLicenseStatus",
//     "Owner Full Name": "ownerFullNameStatus",
//     "Owner Date of Birth": "ownerDobStatus",
//     "Owner PAN": "ownerPanStatus",
//     "Owner Aadhaar": "ownerAadhaarStatus",
//     "Owner Mobile": "ownerMobileStatus",
//     "Owner Email": "ownerEmailStatus",
//     "Owner Address": "ownerAddressStatus",
//     "Owner PAN Document": "ownerPanDocumentStatus",
//     "Owner Aadhaar Document": "ownerAadhaarDocumentStatus",
//     "Owner Image": "ownerSelfieStatus",
// };

// // Company Type options - Updated to match API enum values
// const companyTypeOptions = [
//     "PROPRIETORSHIP",
//     "PARTNERSHIP",
//     "LLP",
//     "PRIVATE_LIMITED"
// ];

// // Display map for user-friendly names
// const companyTypeDisplayMap = {
//     "PROPRIETORSHIP": "Proprietorship",
//     "PARTNERSHIP": "Partnership",
//     "LLP": "Limited Liability Partnership (LLP)",
//     "PRIVATE_LIMITED": "Private Limited"
// };

// // Safe date conversion utility
// const safeDateToISOString = (dateString) => {
//     if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "";

//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) return "";

//     return date.toISOString().split("T")[0];
// };

// // Safe date display utility
// const safeDateDisplay = (dateString) => {
//     if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "N/A";

//     const date = new Date(dateString);
//     if (isNaN(date.getTime())) return "N/A";

//     return date.toLocaleDateString();
// };

// // Format date function for table display
// const formatDate = (dateString) => {
//     if (!dateString) return "N/A";

//     try {
//         const date = new Date(dateString);
//         if (isNaN(date.getTime())) return "N/A";

//         return date.toLocaleDateString('en-GB', {
//             day: '2-digit',
//             month: '2-digit',
//             year: 'numeric'
//         });
//     } catch (error) {
//         return "N/A";
//     }
// };

// // Add this function to check if a field has valid data
// const hasValidData = (row, companyVerificationData) => {
//     if (!row || !companyVerificationData) return false;

//     const field = row.key;
//     const value = row.value;

//     // Check if the value exists and is not empty/"N/A"
//     if (typeof value === 'string') {
//         return value && value !== "N/A" && value.trim() !== "";
//     }

//     if (typeof value === 'object') {
//         // For objects, check if any property has valid data
//         return Object.values(value).some(val =>
//             val && val !== "N/A" && val.toString().trim() !== ""
//         );
//     }

//     return false;
// };

// // Update your isFieldVerified function to check both status AND data presence
// const isFieldVerified = (rowKey, rowValue, companyVerificationData) => {
//     const normalisedKey = rowKey.trim();
//     const statusField = STATUS_FIELD_MAP[normalisedKey];

//     if (!statusField || !companyVerificationData) return false;

//     // If status is explicitly true, it's verified
//     if (companyVerificationData[statusField] === true) return true;

//     // If status is null/undefined but field has valid data, consider it verified
//     if ((companyVerificationData[statusField] === null || companyVerificationData[statusField] === undefined) &&
//         hasValidData({ key: rowKey, value: rowValue }, companyVerificationData)) {
//         return true;
//     }

//     return false;
// };

// // Update your isFieldRejected function similarly
// const isFieldRejected = (rowKey, companyVerificationData) => {
//     const normalisedKey = rowKey.trim();
//     const statusField = STATUS_FIELD_MAP[normalisedKey];

//     if (!statusField || !companyVerificationData) return false;

//     // Only return true if explicitly rejected (false)
//     return companyVerificationData[statusField] === false;
// };

// // UPDATED transformApiData function - Better status handling
// const transformApiData = (data) => {
//     if (!Array.isArray(data)) return [];

//     return data.map(item => ({
//         // ✅ IDs
//         id: item.id || item.userId,
//         userId: item.userId || item.id,

//         // ✅ NAME (FIXED)
//         vendorName:
//             item.userName ||
//             item.vendorName ||
//             item.name ||
//             item.fullName ||
//             item.user?.name ||
//             item.businessName ||
//             item.companyName ||
//             "—",

//         // ✅ EMAIL (FIXED)
//         email:
//             item.email ||
//             item.emailId ||
//             item.user?.email ||
//             "—",

//         // ✅ MOBILE
//         mobileNumber:
//             item.mobileNumber ||
//             item.phone ||
//             item.user?.mobile ||
//             "—",

//         // ✅ COMPANY NAME FIELD ADDED
//         companyName:
//             item.companyName ||
//             item.businessName ||
//             "—",

//         // ✅ REGISTRATION DATE ADDED
//         registrationDate:
//             item.registeredTime ||
//             item.registrationDate ||
//             item.createdAt ||
//             item.createdDate ||
//             null,

//         category:
//             item.category ||
//             item.businessType ||
//             "Professional",

//         // ✅ UPDATED STATUS FIELD - Try multiple fields
//         status:
//             item.verificationStatus ||
//             item.companyVerificationStatus ||
//             item.status ||
//             item.user?.verificationStatus ||
//             "PENDING", // Default to PENDING instead of "—"

//         // ✅ USER TYPE (VERY IMPORTANT)
//         userType:
//             item.userType ||
//             item.user?.userType ||
//             item.role ||
//             "PROFESSIONAL",

//         // keep everything else
//         ...item
//     }));
// };

// // Function to transform company verification API data
// const transformCompanyVerificationData = (data) => {
//     if (!data) return null;

//     return {
//         // IDs
//         id: data.id,
//         userId: data.userId,

//         // Company Details
//         companyName: data.companyName || "N/A",
//         companyType: data.businessType || data.companyType || "N/A",
//         businessType: data.businessType || data.companyType || "N/A", // Add this line
//         companyPan: data.companyPan || "N/A",
//         companyPanDocument: data.companyPanDocument || null,
//         companyGst: data.gstin || data.companyGst || "N/A",
//         cin: data.cin || "N/A",
//         registeredAddress: data.registeredAddress || "N/A",
//         city: data.city || "N/A",
//         state: data.state || "N/A",
//         pincode: data.pincode || "N/A",
//         incorporationCertificate: data.incorporationCertificate || null,
//         gstCertificate: data.gstCertificate || null,
//         tradeLicense: data.tradeLicense || null,

//         // Owner Details
//         ownerFullName: data.ownerFullName || "N/A",
//         ownerDob: data.ownerDob || "N/A",
//         ownerPan: data.ownerPan || "N/A",
//         ownerAadhaar: data.ownerAadhaar || "N/A",
//         ownerMobile: data.ownerMobile || "N/A",
//         ownerEmail: data.ownerEmail || "N/A",
//         ownerAddress: data.ownerAddress || "N/A",
//         ownerPanDocument: data.ownerPanDocument || null,
//         ownerAadhaarDocument: data.ownerAadhaarDocument || null,
//         ownerSelfie: data.ownerSelfie || null,

//         // Status
//         verificationStatus: data.verificationStatus || "PENDING",
//         rejectionReason: data.rejectionReason || null,
//         submittedAt: data.submittedAt || null,
//         verifiedAt: data.verifiedAt || null,

//         // Original data
//         ...data
//     };
// };

// // API Service functions
// const apiService = {
//     getAuthHeaders: () => {
//         const token = localStorage.getItem("authToken");
//         return {
//             headers: {
//                 Authorization: `Bearer ${token}`,
//                 "Content-Type": "application/json"
//             }
//         };
//     },

//     getFormDataHeaders: () => {
//         const token = localStorage.getItem("authToken");
//         return {
//             headers: {
//                 Authorization: `Bearer ${token}`,
//                 "Content-Type": "multipart/form-data"
//             }
//         };
//     },

//     // Fetch all users
//     fetchAllUsers: async () => {
//         const response = await axios.get(API_ENDPOINTS.GET_ALL_USERS, apiService.getAuthHeaders());
//         return response.data;
//     },

//     // Fetch company verification details - using the new endpoint you mentioned
//     fetchCompanyVerification: async (userId) => {
//         try {
//             const response = await axios.get(
//                 API_ENDPOINTS.GET_USER_COMPANY_VERIFICATION(userId),
//                 apiService.getAuthHeaders()
//             );
//             return response.data;
//         } catch (error) {
//             console.warn(`New endpoint failed, trying old endpoint: ${error.message}`);
//             // Fallback to old endpoint if new one fails
//             const fallbackResponse = await axios.get(
//                 API_ENDPOINTS.COMPANY_VERIFICATION(userId),
//                 apiService.getAuthHeaders()
//             );
//             return fallbackResponse.data;
//         }
//     },

//     // NEW: Fetch verification status for all professional users
//     fetchAllVerificationStatuses: async (userIds) => {
//         const token = localStorage.getItem("authToken");
//         if (!token) return {};

//         const statusPromises = userIds.map(async (userId) => {
//             try {
//                 const response = await axios.get(
//                     API_ENDPOINTS.GET_USER_COMPANY_VERIFICATION(userId),
//                     { headers: { Authorization: `Bearer ${token}` } }
//                 );
//                 // Check if response has valid data
//                 if (response.data && response.data.verificationStatus) {
//                     return { userId, status: response.data.verificationStatus };
//                 }
//                 return { userId, status: "PENDING" };
//             } catch (error) {
//                 // Check if it's a 404 error (not found)
//                 if (error.response?.status === 404) {
//                     return { userId, status: "PENDING" };
//                 }
//                 // For other errors, try the old endpoint as fallback
//                 try {
//                     const fallbackResponse = await axios.get(
//                         API_ENDPOINTS.COMPANY_VERIFICATION(userId),
//                         { headers: { Authorization: `Bearer ${token}` } }
//                     );
//                     if (fallbackResponse.data && fallbackResponse.data.verificationStatus) {
//                         return { userId, status: fallbackResponse.data.verificationStatus };
//                     }
//                     return { userId, status: "PENDING" };
//                 } catch (fallbackError) {
//                     return { userId, status: "PENDING" };
//                 }
//             }
//         });

//         const results = await Promise.all(statusPromises);
//         const statusMap = {};
//         results.forEach(result => {
//             statusMap[result.userId] = result.status;
//         });
//         return statusMap;
//     },

//     // Update company verification
//     updateCompanyVerification: async (userId, formData) => {
//         const response = await axios.put(
//             API_ENDPOINTS.COMPANY_VERIFICATION(userId),
//             formData,
//             apiService.getFormDataHeaders()
//         );
//         return response.data;
//     },

//     // Approve verification (old endpoint)
//     approveVerification: async (userId, data) => {
//         const response = await axios.put(
//             API_ENDPOINTS.COMPANY_VERIFICATION_APPROVE(userId),
//             data,
//             apiService.getAuthHeaders()
//         );
//         return response.data;
//     },

//     // Reject verification (old endpoint)
//     rejectVerification: async (userId, data) => {
//         const response = await axios.put(
//             API_ENDPOINTS.COMPANY_VERIFICATION_REJECT(userId),
//             data,
//             apiService.getAuthHeaders()
//         );
//         return response.data;
//     },

//     // Update verification status (new endpoint)
//     updateVerificationStatus: async (verificationId, data) => {
//         const response = await axios.put(
//             API_ENDPOINTS.UPDATE_VERIFICATION_STATUS(verificationId),
//             data,
//             apiService.getAuthHeaders()
//         );
//         return response.data;
//     }
// };

// /* ---------------- component ---------------- */
// const ProfessionalUser = () => {
//     /* -------- list‑screen state -------- */
//     const [rolesData, setRolesData] = useState([]);
//     const [statusFilter, setStatusFilter] = useState("");
//     const [filteredData, setFilteredData] = useState([]);
//     const [verificationStatuses, setVerificationStatuses] = useState({}); // Store verification statuses
//     const { showLoader, hideLoader } = useLoader();

//     /* -------- detail‑screen state -------- */
//     const [selectedClient, setSelectedClient] = useState(null);
//     const [companyVerificationData, setCompanyVerificationData] = useState(null);
//     const [loading, setLoading] = useState(false);

//     const [rows, setRows] = useState(getDefaultClientDetailsRows());
//     const [verifiedRows, setVerifiedRows] = useState([]);
//     const [rejectedRows, setRejectedRows] = useState([]);
//     const [isApproved, setIsApproved] = useState(false);
//     const [imageLoadErrors, setImageLoadErrors] = useState(new Set());

//     const fileInputRef = useRef(null);
//     const [vendorData, setVendorData] = useState({});
//     const [rowId, setRowId] = useState(null);

//     // State for reject modal/dropdown
//     const [showRejectDropdown, setShowRejectDropdown] = useState(false);
//     const [rejectionDescription, setRejectionDescription] = useState("");

//     // Add loading states for approve and reject
//     const [isApproving, setIsApproving] = useState(false);
//     const [isRejecting, setIsRejecting] = useState(false);

//     // Simple image error handler
//     const handleImageError = (imageUrl, fieldName, index) => {
//         const errorKey = `${fieldName}-${index}`;
//         setImageLoadErrors(prev => new Set([...prev, errorKey]));
//     };

//     const handleImageLoad = (imageUrl, fieldName, index) => {
//         const errorKey = `${fieldName}-${index}`;
//         setImageLoadErrors(prev => {
//             const newSet = new Set(prev);
//             newSet.delete(errorKey);
//             return newSet;
//         });
//     };

//     const isImageFailed = (fieldName, index) => {
//         return imageLoadErrors.has(`${fieldName}-${index}`);
//     };

//     // Export to Excel function
//     const exportToExcel = () => {
//         if (filteredData.length === 0) {
//             alert("No data to export");
//             return;
//         }

//         try {
//             // Prepare data for export
//             const exportData = filteredData.map((item, index) => ({
//                 "S.No": index + 1,
//                 "Name": item.vendorName || "—",
//                 "User ID": item.userId || item.id || "—",
//                 "Email": item.email || "—",
//                 "Company Name": item.companyName || "—",
//                 "Phone Number": item.mobileNumber || "—",
//                 "Registration Date": formatDate(item.registrationDate) || "N/A",
//                 "User Type": item.userType || "—",
//                 "Verification Status": item.verificationStatus || item.status || "PENDING"
//             }));

//             // Create worksheet
//             const ws = XLSX.utils.json_to_sheet(exportData);

//             // Create workbook
//             const wb = XLSX.utils.book_new();
//             XLSX.utils.book_append_sheet(wb, ws, "Professional Users");

//             // Generate file name with timestamp
//             const timestamp = new Date().toISOString().split('T')[0];
//             const fileName = `Professional_Users_${timestamp}.xlsx`;

//             // Save file
//             XLSX.writeFile(wb, fileName);

//             alert(`Exported ${exportData.length} records to ${fileName}`);
//         } catch (error) {
//             console.error("Export error:", error);
//             alert("Failed to export data: " + error.message);
//         }
//     };

//     // Fetch company verification details
//     const fetchCompanyVerificationDetails = async (userId) => {
//         if (!userId) return;
//         setLoading(true);

//         try {
//             const data = await apiService.fetchCompanyVerification(userId);
//             console.log("✅ ADMIN FETCH DATA:", data);
//             setCompanyVerificationData(transformCompanyVerificationData(data));
//         } catch (err) {
//             console.error("❌ Fetch error:", err);
//             if (err.response?.status === 404) {
//                 setCompanyVerificationData(null);
//             } else {
//                 // alert(`Failed to fetch verification details: ${err.message}`);
//             }
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Fetch verification status for all users
//     const fetchVerificationStatuses = async (users) => {
//         const userIds = users.map(user => user.userId || user.id);
//         try {
//             const statusMap = await apiService.fetchAllVerificationStatuses(userIds);
//             setVerificationStatuses(statusMap);

//             // Update the rolesData with verification statuses
//             setRolesData(prev => prev.map(user => ({
//                 ...user,
//                 verificationStatus: statusMap[user.userId] || user.verificationStatus || user.status || "PENDING"
//             })));
//         } catch (error) {
//             console.error("Error fetching verification statuses:", error);
//         }
//     };

//     const handleSaveRow = async (rowIndex) => {
//         const token = localStorage.getItem("authToken");
//         if (!token) return alert("Login required");

//         const verificationId = companyVerificationData?.id;
//         if (!verificationId) {
//             alert("Company verification ID missing");
//             return;
//         }

//         const row = rows[rowIndex];
//         const imageField = getImageFieldName(row.key);

//         // ✅ TEXT FIELD MAP
//         const TEXT_FIELD_MAP = {
//             "Company Name": "companyName",
//             "Business Type": "businessType",
//             "Company PAN": "companyPan",
//             "Company GST": "gstin",
//             "CIN (For Companies)": "cin",
//             "Registered Address": "registeredAddress",
//             "City": "city",
//             "State": "state",
//             "Pincode": "pincode",
//             "Owner Full Name": "ownerFullName",
//             "Owner Date of Birth": "ownerDob",
//             "Owner PAN": "ownerPan",
//             "Owner Aadhaar": "ownerAadhaar",
//             "Owner Mobile": "ownerMobile",
//             "Owner Email": "ownerEmail",
//             "Owner Address": "ownerAddress",
//         };

//         const textField = TEXT_FIELD_MAP[row.key];

//         // 🚫 NOTHING TO SAVE
//         if (!imageField && !textField) {
//             alert("This field cannot be updated");
//             return;
//         }

//         const formData = new FormData();

//         // ✅ TEXT UPDATE
//         if (textField) {
//             if (!row.value || row.value === "N/A") {
//                 alert("Please enter a value");
//                 return;
//             }

//             formData.append(
//                 "companyData",
//                 new Blob(
//                     [JSON.stringify({ [textField]: row.value })],
//                     { type: "application/json" }
//                 )
//             );
//         }

//         // ✅ IMAGE UPDATE (ONLY ONE FILE)
//         if (imageField) {
//             const image = row.images?.[row.images.length - 1];
//             if (!image?.file || !(image.file instanceof File)) {
//                 alert("Please select a valid image");
//                 return;
//             }

//             // ✅ BACKEND REQUIRES companyData EVEN FOR IMAGE UPDATES
//             formData.append(
//                 "companyData",
//                 new Blob([JSON.stringify({})], { type: "application/json" })
//             );

//             formData.append(imageField, image.file);
//         }

//         try {
//             await axios.put(
//                 `${API_BASE_URL}/company/verification/${verificationId}`,
//                 formData,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`
//                         // ❌ DO NOT set Content-Type
//                     }
//                 }
//             );

//             // refresh
//             await fetchCompanyVerificationDetails(selectedClient.userId);

//             setRows(prev =>
//                 prev.map((r, i) =>
//                     i === rowIndex ? { ...r, isEditing: false } : r
//                 )
//             );

//         } catch (err) {
//             console.error("❌ Update failed", err);
//             alert(
//                 err.response?.data?.error ||
//                 err.response?.data?.message ||
//                 "Update failed"
//             );
//         }
//     };

//     const fetchProfessionalUsers = async () => {
//         showLoader();

//         try {
//             const data = await apiService.fetchAllUsers();
//             const professionalUsers = transformApiData(data).filter(
//                 u => u.userType?.toUpperCase() === "PROFESSIONAL"
//             );

//             setRolesData(professionalUsers);

//             // Fetch verification statuses for all users
//             await fetchVerificationStatuses(professionalUsers);

//             if (professionalUsers[0]?.userId) {
//                 fetchCompanyVerificationDetails(professionalUsers[0].userId);
//             }

//         } catch (err) {
//             console.error("Failed to fetch users:", err);
//             alert("Failed to fetch users: " + err.message);
//         } finally {
//             hideLoader();
//         }
//     };

//     const getImageFieldName = (key) => {
//         const map = {
//             "Incorporation Certificate": "incorporationCertificate",
//             "GST Certificate": "gstCertificate",
//             "Trade License": "tradeLicense",
//             "Owner PAN Document": "ownerPanDocument",
//             "Owner Aadhaar Document": "ownerAadhaarDocument",
//             "Owner Image": "ownerSelfie",
//             "Company PAN Document": "companyPanDocument",
//         };
//         return map[key] || null;
//     };

//     // Fetch professional users
//     useEffect(() => {
//         fetchProfessionalUsers();
//     }, []);

//     useEffect(() => {
//         let data = rolesData;
//         if (statusFilter) {
//             if (statusFilter === "ALL") {
//                 // Show all
//             } else {
//                 data = data.filter((i) => 
//                     i.verificationStatus === statusFilter || 
//                     i.status === statusFilter
//                 );
//             }
//         }
//         setFilteredData(data);
//     }, [statusFilter, rolesData]);

//     useEffect(() => {
//         if (!selectedClient) {
//             setRows(getDefaultClientDetailsRows());
//             setVerifiedRows([]);
//             setRejectedRows([]);
//             setIsApproved(false);
//             setImageLoadErrors(new Set());
//             return;
//         }

//         const merged = { ...selectedClient, ...(companyVerificationData || {}) };

//         // Image mapping based on API response field names
//         const imageMap = {
//             "Incorporation Certificate": [merged.incorporationCertificate]
//                 .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//             "GST Certificate": [merged.gstCertificate]
//                 .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//             "Trade License": [merged.tradeLicense]
//                 .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//             "Owner PAN Document": [merged.ownerPanDocument]
//                 .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//             "Owner Aadhaar Document": [merged.ownerAadhaarDocument]
//                 .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//             "Owner Image": [merged.ownerSelfie]
//                 .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//             "Company PAN Document": [merged.companyPanDocument]
//                 .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
//         };

//         const newRows = [
//             { key: "Company Name", value: merged.companyName || "N/A" },
//             { key: "Business Type", value: merged.businessType || merged.companyType || "N/A" },
//             { key: "Company PAN", value: merged.companyPan || "N/A" },
//             { key: "Company PAN Document", value: "Company PAN Document" },
//             { key: "Company GST", value: merged.companyGst || merged.gstin || "N/A" },
//             { key: "CIN (For Companies)", value: merged.cin || "N/A" },
//             { key: "Registered Address", value: merged.registeredAddress || "N/A" },
//             { key: "City", value: merged.city || "N/A" },
//             { key: "State", value: merged.state || "N/A" },
//             { key: "Pincode", value: merged.pincode || "N/A" },
//             { key: "Incorporation Certificate", value: "Incorporation Certificate" },
//             { key: "GST Certificate", value: "GST Certificate" },
//             { key: "Trade License", value: "Trade License" },
//             { key: "Owner Full Name", value: merged.ownerFullName || "N/A" },
//             { key: "Owner Date of Birth", value: merged.ownerDob || "N/A" },
//             { key: "Owner PAN", value: merged.ownerPan || "N/A" },
//             { key: "Owner Aadhaar", value: merged.ownerAadhaar || "N/A" },
//             { key: "Owner Mobile", value: merged.ownerMobile || "N/A" },
//             { key: "Owner Email", value: merged.ownerEmail || "N/A" },
//             { key: "Owner Address", value: merged.ownerAddress || "N/A" },
//             { key: "Owner PAN Document", value: "Owner PAN Document" },
//             { key: "Owner Aadhaar Document", value: "Owner Aadhaar Document" },
//             { key: "Owner Image", value: "Owner Image" },
//         ];

//         const updatedRows = newRows.map((row) => ({
//             ...row,
//             images: imageMap[row.key] || [],
//         }));

//         setRows(updatedRows.map((r) => ({ ...r, isEditing: false })));
//         setVerifiedRows([]);
//         setRejectedRows([]);
//         setIsApproved(false);
//         setImageLoadErrors(new Set());
//     }, [selectedClient, companyVerificationData]);

//     const handleViewClick = (client) => {
//         console.log("👁️ VIEW CLICKED FOR CLIENT:", client);
//         setSelectedClient(client);
//         const userId = client?.userId;
//         console.log("🔍 FETCHING COMPANY VERIFICATION DETAILS FOR USER ID:", userId);
//         fetchCompanyVerificationDetails(userId);
//     };

//     const handleReject = async (i) => {
//         const normalisedKey = rows[i].key.trim();
//         const statusField = STATUS_FIELD_MAP[normalisedKey];

//         if (!statusField) {
//             setRejectedRows(prev => (prev.includes(i) ? prev : [...prev, i]));
//             return;
//         }

//         const userId = selectedClient?.userId;
//         if (!userId) return alert("User ID is missing – cannot update.");

//         try {
//             const data = {
//                 verificationStatus: "REJECTED",
//                 rejectionReason: "Field rejected: " + rows[i].key
//             };

//             // Try the new endpoint first
//             const verificationId = companyVerificationData?.id;
//             if (verificationId) {
//                 await apiService.updateVerificationStatus(verificationId, data);
//             } else {
//                 // Fallback to old endpoint
//                 await apiService.rejectVerification(userId, data);
//             }

//             alert("Company verification rejected successfully!");
//             fetchCompanyVerificationDetails(userId);
//         } catch (err) {
//             console.error("❌ Reject error:", err);
//             alert(`Failed to reject: ${err.message}`);
//         }
//     };

//     const handleVerifyy = async (i) => {
//         const userId = selectedClient?.userId;
//         if (!userId) return alert("User ID is missing");

//         try {
//             const data = {
//                 verificationStatus: "VERIFIED",
//                 rejectionReason: ""
//             };

//             const verificationId = companyVerificationData?.id;
//             if (verificationId) {
//                 await apiService.updateVerificationStatus(verificationId, data);
//             } else {
//                 await apiService.approveVerification(userId, data);
//             }

//             await fetchCompanyVerificationDetails(userId);
//             alert("Company verification verified successfully!");
//         } catch (err) {
//             console.error("❌ Verify error:", err.response?.data || err.message);
//             alert("Failed to verify company");
//         }
//     };

//     // New function to handle approve all
//     const handleApproveAll = async () => {
//         const userId = selectedClient?.userId;
//         if (!userId) return alert("User ID is missing");

//         setIsApproving(true); // Start loader

//         try {
//             const data = {
//                 verificationStatus: "VERIFIED",
//                 rejectionReason: ""
//             };

//             const verificationId = companyVerificationData?.id;
//             if (verificationId) {
//                 await apiService.updateVerificationStatus(verificationId, data);
//             } else {
//                 await apiService.approveVerification(userId, data);
//             }

//             await fetchCompanyVerificationDetails(userId);
//             alert("Company verified successfully!");
//         } catch (err) {
//             console.error("❌ Approve error:", err.response?.data || err.message);
//             alert("Failed to approve company");
//         } finally {
//             setIsApproving(false); // Stop loader
//         }
//     };

//     // New function to handle reject all with reason
//     const handleRejectAll = async () => {
//         if (!rejectionDescription.trim()) {
//             alert("Please enter a rejection reason");
//             return;
//         }

//         const userId = selectedClient?.userId;
//         if (!userId) return alert("User ID is missing");

//         setIsRejecting(true); // Start loader

//         try {
//             const data = {
//                 verificationStatus: "REJECTED",
//                 rejectionReason: rejectionDescription
//             };

//             // Try the new endpoint first
//             const verificationId = companyVerificationData?.id;
//             if (verificationId) {
//                 await apiService.updateVerificationStatus(verificationId, data);
//             } else {
//                 // Fallback to old endpoint
//                 await apiService.rejectVerification(userId, data);
//             }

//             setShowRejectDropdown(false);
//             setRejectionDescription("");
//             await fetchCompanyVerificationDetails(userId);
//             alert("Company verification rejected successfully!");
//         } catch (err) {
//             console.error("❌ Reject error:", err);
//             alert(`Failed to reject: ${err.message}`);
//         } finally {
//             setIsRejecting(false); // Stop loader
//         }
//     };

//     const handleBackClick = () => setSelectedClient(null);

//     const handleFileChange = (e, index) => {
//         const fileName = e.target.files[0]?.name || "";
//         const updated = [...rows];
//         updated[index].value = fileName;
//         setRows(updated);
//     };

//     // Clean Image Display Component with "-" for missing images
//     const ImageDisplay = ({ images, fieldName }) => {
//         if (!images || images.length === 0) {
//             return (
//                 <div className="text-center">
//                     <span style={{ fontSize: "18px", color: "#6c757d" }}>-</span>
//                 </div>
//             );
//         }

//         return (
//             <div className="d-flex justify-content-center gap-2 flex-wrap">
//                 {images.map((img, idx) => {
//                     const imageUrl = typeof img === 'string' ? img : img.url;
//                     const hasFailed = isImageFailed(fieldName, idx);

//                     if (hasFailed || !imageUrl) {
//                         return (
//                             <div key={idx} className="text-center">
//                                 <span style={{ fontSize: "18px", color: "#6c757d" }}>-</span>
//                             </div>
//                         );
//                     }

//                     // For selfie, show larger image
//                     const isSelfie = fieldName === "Owner Image";

//                     return (
//                         <div key={idx} className="text-center position-relative">
//                             <img
//                                 src={imageUrl}
//                                 alt={`${fieldName}-${idx}`}
//                                 style={{
//                                     width: isSelfie ? "80px" : "60px",
//                                     height: isSelfie ? "80px" : "60px",
//                                     borderRadius: "6px",
//                                     objectFit: "cover",
//                                     border: "1px solid #dee2e6",
//                                 }}
//                                 onError={() => handleImageError(imageUrl, fieldName, idx)}
//                                 onLoad={() => handleImageLoad(imageUrl, fieldName, idx)}
//                             />
//                             {isSelfie && (
//                                 <div className="mt-1 small text-muted">Image</div>
//                             )}
//                         </div>
//                     );
//                 })}
//             </div>
//         );
//     };

//     // Function to get badge color based on status
//     const getStatusBadgeColor = (status) => {
//         if (!status) return "bg-secondary";
//         if (status === "VERIFIED" || status === "APPROVED") return "bg-success";
//         if (status === "REJECTED") return "bg-danger";
//         if (status === "PENDING") return "bg-warning";
//         return "bg-secondary";
//     };

//     // Function to get display text for status
//     const getStatusDisplayText = (status) => {
//         if (!status) return "Pending";
//         return status;
//     };

//     return (
//         <div className="container-fluid">
//             <div className="row">
//                 <div className="col-lg-12" style={{ marginTop: "10px" }}>
//                     <div className="client" style={{ overflowY: "auto", height: "500px" }}>
//                         {!selectedClient ? (
//                             <>
//                                 <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "10px" }}>
//                                     <div></div>
//                                     <div className="pe-3 d-flex gap-2 align-items-center">
//                                         {/* Export Button */}
//                                         <button
//                                             onClick={exportToExcel}
//                                             className="btn btn-success btn-sm d-flex align-items-center"
//                                             style={{ minWidth: "100px" }}
//                                             disabled={filteredData.length === 0}
//                                         >
//                                             <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" className="bi bi-download me-2" viewBox="0 0 16 16">
//                                                 <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5z"/>
//                                                 <path d="M7.646 11.854a.5.5 0 0 0 .708 0l3-3a.5.5 0 0 0-.708-.708L8.5 10.293V1.5a.5.5 0 0 0-1 0v8.793L5.354 8.146a.5.5 0 1 0-.708.708l3 3z"/>
//                                             </svg>
//                                             Export
//                                         </button>

//                                         {/* Status Filter Dropdown */}
//                                         <select 
//                                             className="form-select form-select-sm" 
//                                             style={{ width: "200px" }}
//                                             value={statusFilter}
//                                             onChange={(e) => setStatusFilter(e.target.value)}
//                                         >
//                                             <option value="">All Statuses</option>
//                                             <option value="VERIFIED">Verified</option>
//                                             <option value="APPROVED">Approved</option>
//                                             <option value="PENDING">Pending</option>
//                                             <option value="REJECTED">Rejected</option>
//                                             {/* NOT_SUBMITTED option removed as requested */}
//                                         </select>
//                                     </div>
//                                 </div>

//                                 <div className="sed pe-3">
//                                     <table style={tableStyle} className="table table-striped">
//                                         <thead>
//                                             <tr>
//                                                 <th style={thStyle}>S.NO</th>
//                                                 <th style={thStyle}>Name</th>
//                                                 <th style={thStyle}>User ID</th>
//                                                 <th style={thStyle}>Email</th>
//                                                 <th style={thStyle}>Company Name</th>
//                                                 <th style={thStyle}>Phone Number</th>
//                                                 <th style={thStyle}>Registration Date</th>
//                                                 <th style={thStyle}>User Type</th>
//                                                 <th style={thStyle}>Verification Status</th>
//                                                 <th style={thStyle}>Actions</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {filteredData.length ? (
//                                                 filteredData.map((c, idx) => {
//                                                     // Get status from verificationStatus or status field
//                                                     const userStatus = c.verificationStatus || c.status || "PENDING";
//                                                     return (
//                                                         <tr key={c.id || idx}>
//                                                             <td style={thTdStyle}>{idx + 1}</td>
//                                                             <td style={thTdStyle}>{c?.vendorName || "—"}</td>
//                                                             <td style={thTdStyle}>{c?.userId || c?.id || "—"}</td>
//                                                             <td style={thTdStyle}>{c?.email || "—"}</td>
//                                                             <td style={thTdStyle}>{c?.companyName || "—"}</td>
//                                                             <td style={thTdStyle}>{c?.mobileNumber || "—"}</td>
//                                                             <td style={thTdStyle}>{formatDate(c?.registrationDate) || "N/A"}</td>
//                                                             <td style={thTdStyle}>{c?.userType || "—"}</td>
//                                                             <td style={thTdStyle}>
//                                                                 <span className={`badge ${getStatusBadgeColor(userStatus)}`}>
//                                                                     {getStatusDisplayText(userStatus)}
//                                                                 </span>
//                                                             </td>
//                                                             <td style={thTdStyle}>
//                                                                 <button
//                                                                     style={{ ...buttonStyle, color: "rgb(230 109 51)", fontWeight: "bold" }}
//                                                                     onClick={() => handleViewClick(c)}
//                                                                 >
//                                                                     View
//                                                                 </button>
//                                                             </td>
//                                                         </tr>
//                                                     );
//                                                 })
//                                             ) : (
//                                                 <tr>
//                                                     <td style={thTdStyle} colSpan={10}>
//                                                         No data available
//                                                     </td>
//                                                 </tr>
//                                             )}
//                                         </tbody>
//                                     </table>
//                                 </div>
//                             </>
//                         ) : (
//                             <div className="mt-4 rounded-3 shadow-sm">
//                                 <div className="d-flex align-items-center mb-4">
//                                     <button
//                                         onClick={handleBackClick}
//                                         className="btn fw-bold px-4 py-2"
//                                         style={{ backgroundColor: "rgb(230 109 51)", color: "#fff" }}
//                                     >
//                                         Back to List
//                                     </button>
//                                     {companyVerificationData && (
//                                         <div className="ms-3">

//                                         </div>
//                                     )}
//                                 </div>

//                                 {loading && (
//                                     <div className="text-center my-4">
//                                         <span className="spinner-border text-primary" />
//                                     </div>
//                                 )}

//                                 {!loading && (
//                                     <>
//                                         <div className="register mt-4">
//                                             <div className="registertable bo2">
//                                                 <table className="table table-bordered table-striped align-middle mt-4 w-100">
//                                                     <thead>
//                                                         <tr>
//                                                             <th style={detailThStyle}>Field</th>
//                                                             <th style={detailThStyle}>Value</th>
//                                                             <th style={detailThStyle}>Image</th>
//                                                             <th style={detailThStyle}>Status</th>
//                                                         </tr>
//                                                     </thead>

//                                                     <tbody>
//                                                         {rows.map((r, i) => {
//                                                             const isEditing = r.isEditing || false;

//                                                             const handleInputChange = (field, value) => {
//                                                                 setRows((prevRows) =>
//                                                                     prevRows.map((row, idx) =>
//                                                                         idx === i
//                                                                             ? {
//                                                                                 ...row,
//                                                                                 value:
//                                                                                     typeof row.value === "object"
//                                                                                         ? { ...row.value, [field]: value }
//                                                                                         : value,
//                                                                             }
//                                                                             : row
//                                                                     )
//                                                                 );
//                                                             };

//                                                             // Handle Company Type selection
//                                                             const handleCompanyTypeChange = (selectedValue) => {
//                                                                 setRows((prevRows) =>
//                                                                     prevRows.map((row, idx) =>
//                                                                         idx === i
//                                                                             ? {
//                                                                                 ...row,
//                                                                                 value: selectedValue,
//                                                                             }
//                                                                             : row
//                                                                     )
//                                                                 );
//                                                             };

//                                                             const handleImageChange = (e) => {
//                                                                 const files = Array.from(e.target.files);
//                                                                 const newImages = files.map((file) => ({
//                                                                     url: URL.createObjectURL(file),
//                                                                     file
//                                                                 }));

//                                                                 setRows(prev =>
//                                                                     prev.map((row, idx) =>
//                                                                         idx === i
//                                                                             ? {
//                                                                                 ...row,
//                                                                                 images: [...(row.images || []), ...newImages]
//                                                                             }
//                                                                             : row
//                                                                     )
//                                                                 );
//                                                             };

//                                                             return (
//                                                                 <tr key={r.key || i}>
//                                                                     <td className="fw-bold text-center align-middle">{r.key}</td>

//                                                                     <td className="text-start align-middle">
//                                                                         {r.key === "Business Type" ? (
//                                                                             isEditing ? (
//                                                                                 <select
//                                                                                     value={r.value || ""}
//                                                                                     onChange={(e) => handleCompanyTypeChange(e.target.value)}
//                                                                                     className="form-select w-75"
//                                                                                 >
//                                                                                     <option value="">Select Business Type</option>
//                                                                                     {companyTypeOptions.map((option) => (
//                                                                                         <option key={option} value={option}>
//                                                                                             {companyTypeDisplayMap[option] || option}
//                                                                                         </option>
//                                                                                     ))}
//                                                                                 </select>
//                                                                             ) : (
//                                                                                 companyTypeDisplayMap[r.value] || r.value || "N/A"
//                                                                             )
//                                                                         ) : r.key === "Owner Date of Birth" ? (
//                                                                             isEditing ? (
//                                                                                 <input
//                                                                                     type="date"
//                                                                                     value={safeDateToISOString(r.value)}
//                                                                                     onChange={(e) => handleInputChange("value", e.target.value)}
//                                                                                     className="form-control d-inline-block w-75"
//                                                                                 />
//                                                                             ) : (
//                                                                                 safeDateDisplay(r.value)
//                                                                             )
//                                                                         ) : r.key === "Incorporation Certificate" ? (
//                                                                             "Incorporation Certificate"
//                                                                         ) : r.key === "GST Certificate" ? (
//                                                                             "GST Certificate"
//                                                                         ) : r.key === "Trade License" ? (
//                                                                             "Trade License"
//                                                                         ) : r.key === "Owner PAN Document" ? (
//                                                                             "Owner PAN Document"
//                                                                         ) : r.key === "Owner Aadhaar Document" ? (
//                                                                             "Owner Aadhaar Document"
//                                                                         ) : r.key === "Owner Image" ? (
//                                                                             "Owner Image"
//                                                                         ) : r.key === "Company PAN Document" ? (
//                                                                             "Company PAN Document"
//                                                                         ) : (
//                                                                             isEditing ? (
//                                                                                 <input
//                                                                                     type="text"
//                                                                                     value={r.value || ""}
//                                                                                     onChange={(e) => handleInputChange("value", e.target.value)}
//                                                                                     className="form-control d-inline-block w-75"
//                                                                                 />
//                                                                             ) : (
//                                                                                 r.value || "N/A"
//                                                                             )
//                                                                         )}
//                                                                     </td>

//                                                                     <td className="text-center align-middle">
//                                                                         {isImageField(r.key) ? (
//                                                                             <>
//                                                                                 {isEditing && (
//                                                                                     <input
//                                                                                         type="file"
//                                                                                         multiple={r.key === "Owner Aadhaar Document"}
//                                                                                         accept="image/*,.pdf"
//                                                                                         onChange={handleImageChange}
//                                                                                         className="form-control mb-2"
//                                                                                     />
//                                                                                 )}
//                                                                                 <ImageDisplay images={r.images} fieldName={r.key} />
//                                                                             </>
//                                                                         ) : (
//                                                                             <span style={{ fontSize: "18px", color: "#6c757d" }}>-</span>
//                                                                         )}
//                                                                     </td>

//                                                                     <td className="text-center align-middle">
//                                                                         {isEditing ? (
//                                                                             <>
//                                                                                 <button
//                                                                                     className="btn btn-sm btn-success me-2"
//                                                                                     style={{ minWidth: 80 }}
//                                                                                     onClick={() => handleSaveRow(i)}
//                                                                                 >
//                                                                                     Save
//                                                                                 </button>
//                                                                                 <button
//                                                                                     className="btn btn-sm btn-secondary"
//                                                                                     style={{ minWidth: 80 }}
//                                                                                     onClick={() =>
//                                                                                         setRows((prev) =>
//                                                                                             prev.map((row, idx) =>
//                                                                                                 idx === i ? { ...row, isEditing: false } : row
//                                                                                             )
//                                                                                         )
//                                                                                     }
//                                                                                 >
//                                                                                     Cancel
//                                                                                 </button>
//                                                                             </>
//                                                                         ) : (
//                                                                             <div style={{ display: "flex", gap: "10px" }}>
//                                                                                 <button
//                                                                                     className="btn btn-sm btn-primary"
//                                                                                     style={{ minWidth: 80 }}
//                                                                                     onClick={() =>
//                                                                                         setRows((prev) =>
//                                                                                             prev.map((row, idx) =>
//                                                                                                 idx === i ? { ...row, isEditing: true } : row
//                                                                                             )
//                                                                                         )
//                                                                                     }
//                                                                                 >
//                                                                                     Edit
//                                                                                 </button>
//                                                                             </div>
//                                                                         )}
//                                                                     </td>
//                                                                 </tr>
//                                                             );
//                                                         })}
//                                                     </tbody>
//                                                 </table>
//                                             </div>
//                                         </div>

//                                         {/* Approve and Reject Buttons at Bottom - FIXED LAYOUT */}
//                                         <div className="d-flex justify-content-center gap-3 mt-4 mb-4 p-3 border-top position-relative">
//                                             <div className="d-flex gap-3 align-items-start position-relative">
//                                                 {/* Conditionally render Approve button or Approved status */}
//                                                 {companyVerificationData?.verificationStatus === "VERIFIED" || companyVerificationData?.verificationStatus === "APPROVED" ? (
//                                                     <div className="d-flex align-items-center">
//                                                         <span className="badge bg-success p-2 fs-6">Approved</span>
//                                                     </div>
//                                                 ) : (
//                                                     <button
//                                                         className="btn btn-success px-4 py-2 fw-bold"
//                                                         style={{ minWidth: "120px" }}
//                                                         onClick={handleApproveAll}
//                                                         disabled={isApproving || isRejecting}
//                                                     >
//                                                         {isApproving ? (
//                                                             <>
//                                                                 <span className="spinner-border spinner-border-sm me-2"></span>
//                                                                 Approving...
//                                                             </>
//                                                         ) : (
//                                                             "Approve"
//                                                         )}
//                                                     </button>
//                                                 )}

//                                                 {/* Conditionally render Reject button or nothing */}
//                                                 {companyVerificationData?.verificationStatus !== "VERIFIED" &&
//                                                     companyVerificationData?.verificationStatus !== "APPROVED" && (
//                                                         <div className="position-relative">
//                                                             {showRejectDropdown ? (
//                                                                 <div className="card p-3 shadow-sm" style={{
//                                                                     width: "300px",
//                                                                     position: "absolute",
//                                                                     top: "100%",
//                                                                     left: "0",
//                                                                     marginTop: "0px",
//                                                                     zIndex: 1000
//                                                                 }}>
//                                                                     <div className="mb-3">
//                                                                         <label className="form-label fw-bold">Rejection Reason</label>
//                                                                         <textarea
//                                                                             className="form-control"
//                                                                             rows="3"
//                                                                             placeholder="Enter rejection reason..."
//                                                                             value={rejectionDescription}
//                                                                             onChange={(e) => setRejectionDescription(e.target.value)}
//                                                                             disabled={isApproving || isRejecting}
//                                                                         />
//                                                                     </div>

//                                                                     <div className="d-flex gap-2">
//                                                                         <button
//                                                                             className="btn btn-danger flex-grow-1"
//                                                                             onClick={handleRejectAll}
//                                                                             disabled={!rejectionDescription.trim() || isApproving || isRejecting}
//                                                                         >
//                                                                             {isRejecting ? (
//                                                                                 <>
//                                                                                     <span className="spinner-border spinner-border-sm me-2"></span>
//                                                                                     Rejecting...
//                                                                                 </>
//                                                                             ) : (
//                                                                                 "Confirm Reject"
//                                                                             )}
//                                                                         </button>
//                                                                         <button
//                                                                             className="btn btn-secondary"
//                                                                             onClick={() => {
//                                                                                 setShowRejectDropdown(false);
//                                                                                 setRejectionDescription("");
//                                                                             }}
//                                                                             disabled={isApproving || isRejecting}
//                                                                         >
//                                                                             Cancel
//                                                                         </button>
//                                                                     </div>
//                                                                 </div>
//                                                             ) : (
//                                                                 <button
//                                                                     className="btn btn-danger px-4 py-2 fw-bold"
//                                                                     style={{ minWidth: "120px" }}
//                                                                     onClick={() => setShowRejectDropdown(true)}
//                                                                     disabled={companyVerificationData?.verificationStatus === "REJECTED" || isApproving || isRejecting}
//                                                                 >
//                                                                     {isRejecting ? (
//                                                                         <>
//                                                                             <span className="spinner-border spinner-border-sm me-2"></span>
//                                                                             Rejecting...
//                                                                         </>
//                                                                     ) : (
//                                                                         "Reject"
//                                                                     )}
//                                                                 </button>
//                                                             )}
//                                                         </div>
//                                                     )}
//                                             </div>
//                                         </div>
//                                     </>
//                                 )}
//                             </div>
//                         )}
//                     </div>
//                 </div>
//             </div>
//         </div>
//     );
// };

// const tableStyle = { width: "100%", borderCollapse: "collapse", marginTop: 5 };
// const thTdStyle = { border: "1px solid #ddd", textAlign: "center" };
// const thStyle = { ...thTdStyle, backgroundColor: "rgb(230 109 51)", color: "#fff", fontWeight: "bold", maxWidth: "70px" };
// const buttonStyle = { backgroundColor: "transparent", border: "none", cursor: "pointer" };

// const detailThStyle = {
//     ...thTdStyle,
//     backgroundColor: "rgb(230 109 51)",
//     color: "#fff",
//     fontWeight: 600,
//     padding: "0.75rem",
//     verticalAlign: "middle",
//     border: "1px solid #dee2e6",
//     textAlign: "center"
// };

// export default ProfessionalUser;

















import React, { useState, useEffect, useRef, useMemo } from "react";
import axios from "axios";
import * as XLSX from 'xlsx'; // Import XLSX for Excel export
import { Link } from "react-router-dom";
import { useLoader } from '../../../../context/LoaderProvider.jsx';

// API Base URL - Define it once and reuse
const API_BASE_URL = "https://backend.maamaas.com/subscription/api";

const REQUIRED_IMAGE_FIELDS = [
    "Incorporation Certificate",
    "GST Certificate",
    "Trade License",
    "Owner PAN Document",
    "Owner Aadhaar Document",
    "Owner Image",
    "Company PAN Document"
];
const isImageField = (rowKey) => REQUIRED_IMAGE_FIELDS.includes(rowKey);

// API Endpoints
const API_ENDPOINTS = {
    GET_ALL_USERS: `${API_BASE_URL}/admin/getallusers`,
    COMPANY_VERIFICATION: (userId) => `${API_BASE_URL}/company/verification/${userId}`,
    COMPANY_VERIFICATION_APPROVE: (userId) => `${API_BASE_URL}/admin/company/verification/approve/${userId}`,
    COMPANY_VERIFICATION_REJECT: (userId) => `${API_BASE_URL}/admin/company/verification/reject/${userId}`,
    GET_USER_COMPANY_VERIFICATION: (userId) => `${API_BASE_URL}/user/company/verification/${userId}`,
    // Add the new status update endpoint
    UPDATE_VERIFICATION_STATUS: (verificationId) => `${API_BASE_URL}/company/verification/${verificationId}/status`
};

const getDefaultClientDetailsRows = () => [
    { key: "Company Name", value: "", isUpload: false },
    { key: "Business Type", value: "", isUpload: false },
    { key: "Company PAN", value: "", isUpload: false },
    { key: "Company GST", value: "", isUpload: false },
    { key: "CIN (For Companies)", value: "", isUpload: false },
    { key: "Registered Address", value: "", isUpload: false },
    { key: "City", value: "", isUpload: false },
    { key: "State", value: "", isUpload: false },
    { key: "Pincode", value: "", isUpload: false },
    { key: "Incorporation Certificate", value: null, isUpload: true },
    { key: "GST Certificate", value: null, isUpload: true },
    { key: "Trade License", value: null, isUpload: true },
    { key: "Owner Full Name", value: "", isUpload: false },
    { key: "Owner Date of Birth", value: "", isUpload: false },
    { key: "Owner PAN", value: "", isUpload: false },
    { key: "Owner Aadhaar", value: "", isUpload: false },
    { key: "Owner Mobile", value: "", isUpload: false },
    { key: "Owner Email", value: "", isUpload: false },
    { key: "Owner Address", value: "", isUpload: false },
    { key: "Owner PAN Document", value: null, isUpload: true },
    { key: "Owner Aadhaar Document", value: null, isUpload: true },
    { key: "Owner Image", value: null, isUpload: true },
];

const STATUS_FIELD_MAP = {
    "Company Name": "companyNameStatus",
    "Business Type": "companyTypeStatus",
    "Company PAN": "companyPanStatus",
    "Company GST": "companyGstStatus",
    "CIN (For Companies)": "cinStatus",
    "Registered Address": "registeredAddressStatus",
    "City": "cityStatus",
    "State": "stateStatus",
    "Pincode": "pincodeStatus",
    "Incorporation Certificate": "incorporationCertificateStatus",
    "GST Certificate": "gstCertificateStatus",
    "Trade License": "tradeLicenseStatus",
    "Owner Full Name": "ownerFullNameStatus",
    "Owner Date of Birth": "ownerDobStatus",
    "Owner PAN": "ownerPanStatus",
    "Owner Aadhaar": "ownerAadhaarStatus",
    "Owner Mobile": "ownerMobileStatus",
    "Owner Email": "ownerEmailStatus",
    "Owner Address": "ownerAddressStatus",
    "Owner PAN Document": "ownerPanDocumentStatus",
    "Owner Aadhaar Document": "ownerAadhaarDocumentStatus",
    "Owner Image": "ownerSelfieStatus",
};

// Company Type options - Updated to match API enum values
const companyTypeOptions = [
    "PROPRIETORSHIP",
    "PARTNERSHIP",
    "LLP",
    "PRIVATE_LIMITED"
];

// Display map for user-friendly names
const companyTypeDisplayMap = {
    "PROPRIETORSHIP": "Proprietorship",
    "PARTNERSHIP": "Partnership",
    "LLP": "Limited Liability Partnership (LLP)",
    "PRIVATE_LIMITED": "Private Limited"
};

// Safe date conversion utility
const safeDateToISOString = (dateString) => {
    if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "";

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "";

    return date.toISOString().split("T")[0];
};

// Safe date display utility
const safeDateDisplay = (dateString) => {
    if (!dateString || dateString === "N/A" || dateString === "Invalid Date") return "N/A";

    const date = new Date(dateString);
    if (isNaN(date.getTime())) return "N/A";

    return date.toLocaleDateString();
};

// Format date function for table display
const formatDate = (dateString) => {
    if (!dateString) return "N/A";

    try {
        const date = new Date(dateString);
        if (isNaN(date.getTime())) return "N/A";

        return date.toLocaleDateString('en-GB', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric'
        });
    } catch (error) {
        return "N/A";
    }
};

// Add this function to check if a field has valid data
const hasValidData = (row, companyVerificationData) => {
    if (!row || !companyVerificationData) return false;

    const field = row.key;
    const value = row.value;

    // Check if the value exists and is not empty/"N/A"
    if (typeof value === 'string') {
        return value && value !== "N/A" && value.trim() !== "";
    }

    if (typeof value === 'object') {
        // For objects, check if any property has valid data
        return Object.values(value).some(val =>
            val && val !== "N/A" && val.toString().trim() !== ""
        );
    }

    return false;
};

// Update your isFieldVerified function to check both status AND data presence
const isFieldVerified = (rowKey, rowValue, companyVerificationData) => {
    const normalisedKey = rowKey.trim();
    const statusField = STATUS_FIELD_MAP[normalisedKey];

    if (!statusField || !companyVerificationData) return false;

    // If status is explicitly true, it's verified
    if (companyVerificationData[statusField] === true) return true;

    // If status is null/undefined but field has valid data, consider it verified
    if ((companyVerificationData[statusField] === null || companyVerificationData[statusField] === undefined) &&
        hasValidData({ key: rowKey, value: rowValue }, companyVerificationData)) {
        return true;
    }

    return false;
};

// Update your isFieldRejected function similarly
const isFieldRejected = (rowKey, companyVerificationData) => {
    const normalisedKey = rowKey.trim();
    const statusField = STATUS_FIELD_MAP[normalisedKey];

    if (!statusField || !companyVerificationData) return false;

    // Only return true if explicitly rejected (false)
    return companyVerificationData[statusField] === false;
};

// UPDATED transformApiData function - Better status handling
const transformApiData = (data) => {
    if (!Array.isArray(data)) return [];

    return data.map(item => ({
        // ✅ IDs
        id: item.id || item.userId,
        userId: item.userId || item.id,

        // ✅ NAME (FIXED)
        vendorName:
            item.userName ||
            item.vendorName ||
            item.name ||
            item.fullName ||
            item.user?.name ||
            item.businessName ||
            item.companyName ||
            "—",

        // ✅ EMAIL (FIXED)
        email:
            item.email ||
            item.emailId ||
            item.user?.email ||
            "—",

        // ✅ MOBILE
        mobileNumber:
            item.mobileNumber ||
            item.phone ||
            item.user?.mobile ||
            "—",

        // ✅ COMPANY NAME FIELD ADDED
        companyName:
            item.companyName ||
            item.businessName ||
            "—",

        // ✅ REGISTRATION DATE ADDED
        registrationDate:
            item.registeredTime ||
            item.registrationDate ||
            item.createdAt ||
            item.createdDate ||
            null,

        category:
            item.category ||
            item.businessType ||
            "Professional",

        // ✅ UPDATED STATUS FIELD - Try multiple fields
        status:
            item.verificationStatus ||
            item.companyVerificationStatus ||
            item.status ||
            item.user?.verificationStatus ||
            "PENDING", // Default to PENDING instead of "—"

        // ✅ USER TYPE (VERY IMPORTANT)
        userType:
            item.userType ||
            item.user?.userType ||
            item.role ||
            "PROFESSIONAL",

        // keep everything else
        ...item
    }));
};

// Function to transform company verification API data
const transformCompanyVerificationData = (data) => {
    if (!data) return null;

    return {
        // IDs
        id: data.id,
        userId: data.userId,

        // Company Details
        companyName: data.companyName || "N/A",
        companyType: data.businessType || data.companyType || "N/A",
        businessType: data.businessType || data.companyType || "N/A", // Add this line
        companyPan: data.companyPan || "N/A",
        companyPanDocument: data.companyPanDocument || null,
        companyGst: data.gstin || data.companyGst || "N/A",
        cin: data.cin || "N/A",
        registeredAddress: data.registeredAddress || "N/A",
        city: data.city || "N/A",
        state: data.state || "N/A",
        pincode: data.pincode || "N/A",
        incorporationCertificate: data.incorporationCertificate || null,
        gstCertificate: data.gstCertificate || null,
        tradeLicense: data.tradeLicense || null,

        // Owner Details
        ownerFullName: data.ownerFullName || "N/A",
        ownerDob: data.ownerDob || "N/A",
        ownerPan: data.ownerPan || "N/A",
        ownerAadhaar: data.ownerAadhaar || "N/A",
        ownerMobile: data.ownerMobile || "N/A",
        ownerEmail: data.ownerEmail || "N/A",
        ownerAddress: data.ownerAddress || "N/A",
        ownerPanDocument: data.ownerPanDocument || null,
        ownerAadhaarDocument: data.ownerAadhaarDocument || null,
        ownerSelfie: data.ownerSelfie || null,

        // Status
        verificationStatus: data.verificationStatus || "PENDING",
        rejectionReason: data.rejectionReason || null,
        submittedAt: data.submittedAt || null,
        verifiedAt: data.verifiedAt || null,

        // Original data
        ...data
    };
};

// API Service functions
const apiService = {
    getAuthHeaders: () => {
        const token = localStorage.getItem("authToken");
        return {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "application/json"
            }
        };
    },

    getFormDataHeaders: () => {
        const token = localStorage.getItem("authToken");
        return {
            headers: {
                Authorization: `Bearer ${token}`,
                "Content-Type": "multipart/form-data"
            }
        };
    },

    // Fetch all users
    fetchAllUsers: async () => {
        const response = await axios.get(API_ENDPOINTS.GET_ALL_USERS, apiService.getAuthHeaders());
        return response.data;
    },

    // Fetch company verification details - using the new endpoint you mentioned
    fetchCompanyVerification: async (userId) => {
        try {
            const response = await axios.get(
                API_ENDPOINTS.GET_USER_COMPANY_VERIFICATION(userId),
                apiService.getAuthHeaders()
            );
            return response.data;
        } catch (error) {
            console.warn(`New endpoint failed, trying old endpoint: ${error.message}`);
            // Fallback to old endpoint if new one fails
            const fallbackResponse = await axios.get(
                API_ENDPOINTS.COMPANY_VERIFICATION(userId),
                apiService.getAuthHeaders()
            );
            return fallbackResponse.data;
        }
    },

    // NEW: Fetch verification status for all professional users
    fetchAllVerificationStatuses: async (userIds) => {
        const token = localStorage.getItem("authToken");
        if (!token) return {};

        const statusPromises = userIds.map(async (userId) => {
            try {
                const response = await axios.get(
                    API_ENDPOINTS.GET_USER_COMPANY_VERIFICATION(userId),
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                // Check if response has valid data
                if (response.data && response.data.verificationStatus) {
                    return { userId, status: response.data.verificationStatus };
                }
                return { userId, status: "PENDING" };
            } catch (error) {
                // Check if it's a 404 error (not found)
                if (error.response?.status === 404) {
                    return { userId, status: "PENDING" };
                }
                // For other errors, try the old endpoint as fallback
                try {
                    const fallbackResponse = await axios.get(
                        API_ENDPOINTS.COMPANY_VERIFICATION(userId),
                        { headers: { Authorization: `Bearer ${token}` } }
                    );
                    if (fallbackResponse.data && fallbackResponse.data.verificationStatus) {
                        return { userId, status: fallbackResponse.data.verificationStatus };
                    }
                    return { userId, status: "PENDING" };
                } catch (fallbackError) {
                    return { userId, status: "PENDING" };
                }
            }
        });

        const results = await Promise.all(statusPromises);
        const statusMap = {};
        results.forEach(result => {
            statusMap[result.userId] = result.status;
        });
        return statusMap;
    },

    // Update company verification
    updateCompanyVerification: async (userId, formData) => {
        const response = await axios.put(
            API_ENDPOINTS.COMPANY_VERIFICATION(userId),
            formData,
            apiService.getFormDataHeaders()
        );
        return response.data;
    },

    // Approve verification (old endpoint)
    approveVerification: async (userId, data) => {
        const response = await axios.put(
            API_ENDPOINTS.COMPANY_VERIFICATION_APPROVE(userId),
            data,
            apiService.getAuthHeaders()
        );
        return response.data;
    },

    // Reject verification (old endpoint)
    rejectVerification: async (userId, data) => {
        const response = await axios.put(
            API_ENDPOINTS.COMPANY_VERIFICATION_REJECT(userId),
            data,
            apiService.getAuthHeaders()
        );
        return response.data;
    },

    // Update verification status (new endpoint)
    updateVerificationStatus: async (verificationId, data) => {
        const response = await axios.put(
            API_ENDPOINTS.UPDATE_VERIFICATION_STATUS(verificationId),
            data,
            apiService.getAuthHeaders()
        );
        return response.data;
    }
};

/* ---------------- component ---------------- */
// Professional User Tab Component with Fixed Headers
const ProfessionalUser = () => {
    /* -------- list‑screen state -------- */
    const [rolesData, setRolesData] = useState([]);
    const [statusFilter, setStatusFilter] = useState("");
    const [filteredData, setFilteredData] = useState([]);
    const [verificationStatuses, setVerificationStatuses] = useState({}); // Store verification statuses
    const { showLoader, hideLoader } = useLoader();

    /* -------- detail‑screen state -------- */
    const [selectedClient, setSelectedClient] = useState(null);
    const [companyVerificationData, setCompanyVerificationData] = useState(null);
    const [loading, setLoading] = useState(false);

    const [rows, setRows] = useState(getDefaultClientDetailsRows());
    const [verifiedRows, setVerifiedRows] = useState([]);
    const [rejectedRows, setRejectedRows] = useState([]);
    const [isApproved, setIsApproved] = useState(false);
    const [imageLoadErrors, setImageLoadErrors] = useState(new Set());

    const fileInputRef = useRef(null);
    const [vendorData, setVendorData] = useState({});
    const [rowId, setRowId] = useState(null);

    // State for reject modal/dropdown
    const [showRejectDropdown, setShowRejectDropdown] = useState(false);
    const [rejectionDescription, setRejectionDescription] = useState("");

    // Add loading states for approve and reject
    const [isApproving, setIsApproving] = useState(false);
    const [isRejecting, setIsRejecting] = useState(false);

    // NEW: Filter states like Userdetails file
    const [searchType, setSearchType] = useState("userId"); // Default search type
    const [searchQuery, setSearchQuery] = useState("");

    // Search options for dropdown
    const searchOptions = [
        { value: "userId", label: "User ID" },
        { value: "vendorName", label: "Name" },
        { value: "email", label: "Email" },
        { value: "mobileNumber", label: "Phone Number" },
        { value: "companyName", label: "Company Name" }
    ];

    // Status options for dropdown
    const statusOptions = [
        { value: "", label: "All Statuses" },
        { value: "VERIFIED", label: "Verified" },
        { value: "APPROVED", label: "Approved" },
        { value: "PENDING", label: "Pending" },
        { value: "REJECTED", label: "Rejected" }
    ];

    // NEW: Get placeholder text based on search type
    const getPlaceholderText = () => {
        switch (searchType) {
            case "userId": return "Search User ID";
            case "vendorName": return "Search Name";
            case "email": return "Search Email";
            case "mobileNumber": return "Search Phone Number";
            case "companyName": return "Search Company Name";
            default: return "Search...";
        }
    };

    // NEW: Clear all filters
    const clearAllFilters = () => {
        setSearchQuery("");
        setStatusFilter("");
    };

    // NEW: Search filtered data
    const searchFilteredData = useMemo(() => {
        if (!rolesData.length) return [];

        let data = rolesData;

        // Status filter
        if (statusFilter) {
            data = data.filter((item) => {
                if (!item.verificationStatus && !item.status) return false;
                const itemStatus = item.verificationStatus || item.status;
                return itemStatus === statusFilter;
            });
        }

        // Search filter
        if (searchQuery.trim()) {
            const query = searchQuery.toLowerCase().trim();
            data = data.filter((item) => {
                let fieldValue;

                if (searchType === "email") {
                    fieldValue = item.email;
                } else if (searchType === "vendorName") {
                    fieldValue = item.vendorName;
                } else {
                    fieldValue = item[searchType];
                }

                if (!fieldValue) return false;

                // Special handling for phone number search
                if (searchType === "mobileNumber") {
                    const cleanUserMobile = fieldValue.toString().replace(/\D/g, '');
                    const cleanQuery = query.replace(/\D/g, '');
                    return fieldValue.toString().toLowerCase().includes(query) ||
                        cleanUserMobile.includes(cleanQuery);
                }

                // For other fields
                return fieldValue.toString().toLowerCase().includes(query);
            });
        }

        return data;
    }, [rolesData, statusFilter, searchQuery, searchType]);

    // Simple image error handler
    const handleImageError = (imageUrl, fieldName, index) => {
        const errorKey = `${fieldName}-${index}`;
        setImageLoadErrors(prev => new Set([...prev, errorKey]));
    };

    const handleImageLoad = (imageUrl, fieldName, index) => {
        const errorKey = `${fieldName}-${index}`;
        setImageLoadErrors(prev => {
            const newSet = new Set(prev);
            newSet.delete(errorKey);
            return newSet;
        });
    };

    const isImageFailed = (fieldName, index) => {
        return imageLoadErrors.has(`${fieldName}-${index}`);
    };

    // Export to Excel function
    const exportToExcel = () => {
        const exportData = searchFilteredData.length > 0 ? searchFilteredData : rolesData;

        if (exportData.length === 0) {
            alert("No data to export");
            return;
        }

        try {
            // Prepare data for export
            const excelData = exportData.map((item, index) => ({
                "S.No": index + 1,
                "Name": item.vendorName || "—",
                "User ID": item.userId || item.id || "—",
                "Email": item.email || "—",
                "Company Name": item.companyName || "—",
                "Phone Number": item.mobileNumber || "—",
                "Registration Date": formatDate(item.registrationDate) || "N/A",
                "User Type": item.userType || "—",
                "Verification Status": item.verificationStatus || item.status || "PENDING"
            }));

            // Create worksheet
            const ws = XLSX.utils.json_to_sheet(excelData);

            // Create workbook
            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Professional Users");

            // Generate file name with timestamp
            const timestamp = new Date().toISOString().split('T')[0];
            const fileName = `Professional_Users_${timestamp}.xlsx`;

            // Save file
            XLSX.writeFile(wb, fileName);

            alert(`Exported ${excelData.length} records to ${fileName}`);
        } catch (error) {
            console.error("Export error:", error);
            alert("Failed to export data: " + error.message);
        }
    };

    // Fetch company verification details
    const fetchCompanyVerificationDetails = async (userId) => {
        if (!userId) return;
        setLoading(true);

        try {
            const data = await apiService.fetchCompanyVerification(userId);
            console.log("✅ ADMIN FETCH DATA:", data);
            setCompanyVerificationData(transformCompanyVerificationData(data));
        } catch (err) {
            console.error("❌ Fetch error:", err);
            if (err.response?.status === 404) {
                setCompanyVerificationData(null);
            } else {
                // alert(`Failed to fetch verification details: ${err.message}`);
            }
        } finally {
            setLoading(false);
        }
    };

    // Fetch verification status for all users
    const fetchVerificationStatuses = async (users) => {
        const userIds = users.map(user => user.userId || user.id);
        try {
            const statusMap = await apiService.fetchAllVerificationStatuses(userIds);
            setVerificationStatuses(statusMap);

            // Update the rolesData with verification statuses
            setRolesData(prev => prev.map(user => ({
                ...user,
                verificationStatus: statusMap[user.userId] || user.verificationStatus || user.status || "PENDING"
            })));
        } catch (error) {
            console.error("Error fetching verification statuses:", error);
        }
    };

    const handleSaveRow = async (rowIndex) => {
        const token = localStorage.getItem("authToken");
        if (!token) return alert("Login required");

        const verificationId = companyVerificationData?.id;
        if (!verificationId) {
            alert("Company verification ID missing");
            return;
        }

        const row = rows[rowIndex];
        const imageField = getImageFieldName(row.key);

        // ✅ TEXT FIELD MAP
        const TEXT_FIELD_MAP = {
            "Company Name": "companyName",
            "Business Type": "businessType",
            "Company PAN": "companyPan",
            "Company GST": "gstin",
            "CIN (For Companies)": "cin",
            "Registered Address": "registeredAddress",
            "City": "city",
            "State": "state",
            "Pincode": "pincode",
            "Owner Full Name": "ownerFullName",
            "Owner Date of Birth": "ownerDob",
            "Owner PAN": "ownerPan",
            "Owner Aadhaar": "ownerAadhaar",
            "Owner Mobile": "ownerMobile",
            "Owner Email": "ownerEmail",
            "Owner Address": "ownerAddress",
        };

        const textField = TEXT_FIELD_MAP[row.key];

        // 🚫 NOTHING TO SAVE
        if (!imageField && !textField) {
            alert("This field cannot be updated");
            return;
        }

        const formData = new FormData();

        // ✅ TEXT UPDATE
        if (textField) {
            if (!row.value || row.value === "N/A") {
                alert("Please enter a value");
                return;
            }

            formData.append(
                "companyData",
                new Blob(
                    [JSON.stringify({ [textField]: row.value })],
                    { type: "application/json" }
                )
            );
        }

        // ✅ IMAGE UPDATE (ONLY ONE FILE)
        if (imageField) {
            const image = row.images?.[row.images.length - 1];
            if (!image?.file || !(image.file instanceof File)) {
                alert("Please select a valid image");
                return;
            }

            // ✅ BACKEND REQUIRES companyData EVEN FOR IMAGE UPDATES
            formData.append(
                "companyData",
                new Blob([JSON.stringify({})], { type: "application/json" })
            );

            formData.append(imageField, image.file);
        }

        try {
            await axios.put(
                `${API_BASE_URL}/company/verification/${verificationId}`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`
                        // ❌ DO NOT set Content-Type
                    }
                }
            );

            // refresh
            await fetchCompanyVerificationDetails(selectedClient.userId);

            setRows(prev =>
                prev.map((r, i) =>
                    i === rowIndex ? { ...r, isEditing: false } : r
                )
            );

        } catch (err) {
            console.error("❌ Update failed", err);
            alert(
                err.response?.data?.error ||
                err.response?.data?.message ||
                "Update failed"
            );
        }
    };

    const fetchProfessionalUsers = async () => {
        showLoader();

        try {
            const data = await apiService.fetchAllUsers();
            const professionalUsers = transformApiData(data).filter(
                u => u.userType?.toUpperCase() === "PROFESSIONAL"
            );

            setRolesData(professionalUsers);

            // Fetch verification statuses for all users
            await fetchVerificationStatuses(professionalUsers);

            if (professionalUsers[0]?.userId) {
                fetchCompanyVerificationDetails(professionalUsers[0].userId);
            }

        } catch (err) {
            console.error("Failed to fetch users:", err);
            alert("Failed to fetch users: " + err.message);
        } finally {
            hideLoader();
        }
    };

    const getImageFieldName = (key) => {
        const map = {
            "Incorporation Certificate": "incorporationCertificate",
            "GST Certificate": "gstCertificate",
            "Trade License": "tradeLicense",
            "Owner PAN Document": "ownerPanDocument",
            "Owner Aadhaar Document": "ownerAadhaarDocument",
            "Owner Image": "ownerSelfie",
            "Company PAN Document": "companyPanDocument",
        };
        return map[key] || null;
    };

    // Fetch professional users
    useEffect(() => {
        fetchProfessionalUsers();
    }, []);

    // Apply filters to data
    useEffect(() => {
        setFilteredData(searchFilteredData);
    }, [searchFilteredData]);

    useEffect(() => {
        if (!selectedClient) {
            setRows(getDefaultClientDetailsRows());
            setVerifiedRows([]);
            setRejectedRows([]);
            setIsApproved(false);
            setImageLoadErrors(new Set());
            return;
        }

        const merged = { ...selectedClient, ...(companyVerificationData || {}) };

        // Image mapping based on API response field names
        const imageMap = {
            "Incorporation Certificate": [merged.incorporationCertificate]
                .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "GST Certificate": [merged.gstCertificate]
                .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "Trade License": [merged.tradeLicense]
                .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "Owner PAN Document": [merged.ownerPanDocument]
                .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "Owner Aadhaar Document": [merged.ownerAadhaarDocument]
                .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "Owner Image": [merged.ownerSelfie]
                .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
            "Company PAN Document": [merged.companyPanDocument]
                .filter(url => url && url !== "N/A" && typeof url === 'string' && url.trim() !== ''),
        };

        const newRows = [
            { key: "Company Name", value: merged.companyName || "N/A" },
            { key: "Business Type", value: merged.businessType || merged.companyType || "N/A" },
            { key: "Company PAN", value: merged.companyPan || "N/A" },
            { key: "Company PAN Document", value: "Company PAN Document" },
            { key: "Company GST", value: merged.companyGst || merged.gstin || "N/A" },
            { key: "CIN (For Companies)", value: merged.cin || "N/A" },
            { key: "Registered Address", value: merged.registeredAddress || "N/A" },
            { key: "City", value: merged.city || "N/A" },
            { key: "State", value: merged.state || "N/A" },
            { key: "Pincode", value: merged.pincode || "N/A" },
            { key: "Incorporation Certificate", value: "Incorporation Certificate" },
            { key: "GST Certificate", value: "GST Certificate" },
            { key: "Trade License", value: "Trade License" },
            { key: "Owner Full Name", value: merged.ownerFullName || "N/A" },
            { key: "Owner Date of Birth", value: merged.ownerDob || "N/A" },
            { key: "Owner PAN", value: merged.ownerPan || "N/A" },
            { key: "Owner Aadhaar", value: merged.ownerAadhaar || "N/A" },
            { key: "Owner Mobile", value: merged.ownerMobile || "N/A" },
            { key: "Owner Email", value: merged.ownerEmail || "N/A" },
            { key: "Owner Address", value: merged.ownerAddress || "N/A" },
            { key: "Owner PAN Document", value: "Owner PAN Document" },
            { key: "Owner Aadhaar Document", value: "Owner Aadhaar Document" },
            { key: "Owner Image", value: "Owner Image" },
        ];

        const updatedRows = newRows.map((row) => ({
            ...row,
            images: imageMap[row.key] || [],
        }));

        setRows(updatedRows.map((r) => ({ ...r, isEditing: false })));
        setVerifiedRows([]);
        setRejectedRows([]);
        setIsApproved(false);
        setImageLoadErrors(new Set());
    }, [selectedClient, companyVerificationData]);

    const handleViewClick = (client) => {
        console.log("👁️ VIEW CLICKED FOR CLIENT:", client);
        setSelectedClient(client);
        const userId = client?.userId;
        console.log("🔍 FETCHING COMPANY VERIFICATION DETAILS FOR USER ID:", userId);
        fetchCompanyVerificationDetails(userId);
    };

    const handleReject = async (i) => {
        const normalisedKey = rows[i].key.trim();
        const statusField = STATUS_FIELD_MAP[normalisedKey];

        if (!statusField) {
            setRejectedRows(prev => (prev.includes(i) ? prev : [...prev, i]));
            return;
        }

        const userId = selectedClient?.userId;
        if (!userId) return alert("User ID is missing – cannot update.");

        try {
            const data = {
                verificationStatus: "REJECTED",
                rejectionReason: "Field rejected: " + rows[i].key
            };

            // Try the new endpoint first
            const verificationId = companyVerificationData?.id;
            if (verificationId) {
                await apiService.updateVerificationStatus(verificationId, data);
            } else {
                // Fallback to old endpoint
                await apiService.rejectVerification(userId, data);
            }

            alert("Company verification rejected successfully!");
            fetchCompanyVerificationDetails(userId);
        } catch (err) {
            console.error("❌ Reject error:", err);
            alert(`Failed to reject: ${err.message}`);
        }
    };

    const handleVerifyy = async (i) => {
        const userId = selectedClient?.userId;
        if (!userId) return alert("User ID is missing");

        try {
            const data = {
                verificationStatus: "VERIFIED",
                rejectionReason: ""
            };

            const verificationId = companyVerificationData?.id;
            if (verificationId) {
                await apiService.updateVerificationStatus(verificationId, data);
            } else {
                await apiService.approveVerification(userId, data);
            }

            await fetchCompanyVerificationDetails(userId);
            alert("Company verification verified successfully!");
        } catch (err) {
            console.error("❌ Verify error:", err.response?.data || err.message);
            alert("Failed to verify company");
        }
    };

    // New function to handle approve all
    const handleApproveAll = async () => {
        const userId = selectedClient?.userId;
        if (!userId) return alert("User ID is missing");

        setIsApproving(true); // Start loader

        try {
            const data = {
                verificationStatus: "VERIFIED",
                rejectionReason: ""
            };

            const verificationId = companyVerificationData?.id;
            if (verificationId) {
                await apiService.updateVerificationStatus(verificationId, data);
            } else {
                await apiService.approveVerification(userId, data);
            }

            await fetchCompanyVerificationDetails(userId);
            alert("Company verified successfully!");
        } catch (err) {
            console.error("❌ Approve error:", err.response?.data || err.message);
            alert("Failed to approve company");
        } finally {
            setIsApproving(false); // Stop loader
        }
    };

    // New function to handle reject all with reason
    const handleRejectAll = async () => {
        if (!rejectionDescription.trim()) {
            alert("Please enter a rejection reason");
            return;
        }

        const userId = selectedClient?.userId;
        if (!userId) return alert("User ID is missing");

        setIsRejecting(true); // Start loader

        try {
            const data = {
                verificationStatus: "REJECTED",
                rejectionReason: rejectionDescription
            };

            // Try the new endpoint first
            const verificationId = companyVerificationData?.id;
            if (verificationId) {
                await apiService.updateVerificationStatus(verificationId, data);
            } else {
                // Fallback to old endpoint
                await apiService.rejectVerification(userId, data);
            }

            setShowRejectDropdown(false);
            setRejectionDescription("");
            await fetchCompanyVerificationDetails(userId);
            alert("Company verification rejected successfully!");
        } catch (err) {
            console.error("❌ Reject error:", err);
            alert(`Failed to reject: ${err.message}`);
        } finally {
            setIsRejecting(false); // Stop loader
        }
    };

    const handleBackClick = () => setSelectedClient(null);

    const handleFileChange = (e, index) => {
        const fileName = e.target.files[0]?.name || "";
        const updated = [...rows];
        updated[index].value = fileName;
        setRows(updated);
    };

    // Clean Image Display Component with "-" for missing images
    const ImageDisplay = ({ images, fieldName }) => {
        if (!images || images.length === 0) {
            return (
                <div className="text-center">
                    <span style={{ fontSize: "18px", color: "#6c757d" }}>-</span>
                </div>
            );
        }

        return (
            <div className="d-flex justify-content-center gap-2 flex-wrap">
                {images.map((img, idx) => {
                    const imageUrl = typeof img === 'string' ? img : img.url;
                    const hasFailed = isImageFailed(fieldName, idx);

                    if (hasFailed || !imageUrl) {
                        return (
                            <div key={idx} className="text-center">
                                <span style={{ fontSize: "18px", color: "#6c757d" }}>-</span>
                            </div>
                        );
                    }

                    // For selfie, show larger image
                    const isSelfie = fieldName === "Owner Image";

                    return (
                        <div key={idx} className="text-center position-relative">
                            <img
                                src={imageUrl}
                                alt={`${fieldName}-${idx}`}
                                style={{
                                    width: isSelfie ? "80px" : "60px",
                                    height: isSelfie ? "80px" : "60px",
                                    borderRadius: "6px",
                                    objectFit: "cover",
                                    border: "1px solid #dee2e6",
                                }}
                                onError={() => handleImageError(imageUrl, fieldName, idx)}
                                onLoad={() => handleImageLoad(imageUrl, fieldName, idx)}
                            />
                            {isSelfie && (
                                <div className="mt-1 small text-muted">Image</div>
                            )}
                        </div>
                    );
                })}
            </div>
        );
    };

    // Function to get badge color based on status
    const getStatusBadgeColor = (status) => {
        if (!status) return "bg-secondary";
        if (status === "VERIFIED" || status === "APPROVED") return "bg-success";
        if (status === "REJECTED") return "bg-danger";
        if (status === "PENDING") return "bg-warning";
        return "bg-secondary";
    };

    // Function to get display text for status
    const getStatusDisplayText = (status) => {
        if (!status) return "Pending";
        return status;
    };

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-lg-12" style={{ marginTop: "10px" }}>
                    <div className="client" style={{ overflowY: "auto", height: "580px" }}>
                        {!selectedClient ? (
                            <>
                                {/* NEW: Filter Controls like Userdetails file */}
                                <div className="row mb-3 g-2 align-items-center" style={{ marginBottom: '15px' }}>
                                    {/* Search Type Dropdown and Search Input */}
                                    <div className="col-md-auto col-12">
                                        <div className="d-flex align-items-center" style={{ gap: '10px' }}>
                                            {/* Search Type Dropdown */}
                                            <div style={{ minWidth: '150px' }}>
                                                <select
                                                    className="form-select"
                                                    value={searchType}
                                                    onChange={(e) => setSearchType(e.target.value)}
                                                    style={{ height: "40px" }}
                                                >
                                                    {searchOptions.map(option => (
                                                        <option key={option.value} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* Search Input */}
                                            <div style={{ minWidth: '200px' }}>
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder={getPlaceholderText()}
                                                    value={searchQuery}
                                                    onChange={(e) => setSearchQuery(e.target.value)}
                                                    style={{ height: "40px" }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* Status Filter */}
                                    <div className="col-md-auto col-12">
                                        <select
                                            className="form-select"
                                            value={statusFilter}
                                            onChange={(e) => setStatusFilter(e.target.value)}
                                            style={{ maxWidth: '150px', height: "40px" }}
                                        >
                                            {statusOptions.map(option => (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    {/* Clear Filters Button */}
                                    <div className="col-md-auto col-12">
                                        <button
                                            className="btn"
                                            onClick={clearAllFilters}
                                            style={{
                                                backgroundColor: '#6c757d',
                                                color: '#fff',
                                                height: "40px",
                                                padding: "0 15px"
                                            }}
                                        >
                                            Clear Filters
                                        </button>
                                    </div>

                                    {/* Export Button */}
                                    <div className="col-md col-12">
                                        <div className="d-flex justify-content-start justify-content-md-end">
                                            <button
                                                className="btn"
                                                onClick={exportToExcel}
                                                style={{
                                                    backgroundColor: 'rgb(230 109 51)',
                                                    color: '#fff',
                                                    height: "40px",
                                                    padding: "0 20px"
                                                }}
                                            >
                                                Export
                                            </button>
                                        </div>
                                    </div>
                                </div>

                                {/* Table with Fixed Headers */}
                                <div className="professional-table-container" style={{
                                    marginTop: '10px',
                                    border: '1px solid #ddd',
                                    borderRadius: '4px',
                                    overflow: 'hidden'
                                }}>
                                    {/* Fixed Header Table */}
                                    <div style={{
                                        overflow: 'hidden',
                                        backgroundColor: '#fff'

                                    }}>
                                        <table style={{
                                            width: "100%",
                                            borderCollapse: "collapse",
                                            tableLayout: 'fixed'
                                        }}>
                                            <thead>
                                                <tr>
                                                    <th style={{ ...thStyle, width: '50px' }}>S.NO</th>
                                                    <th style={{ ...thStyle, width: '100px' }}>Name</th>
                                                    <th style={{ ...thStyle, width: '80px' }}>User ID</th>
                                                    <th style={{ ...thStyle, width: '120px' }}>Email</th>
                                                    <th style={{ ...thStyle, width: '100px' }}>Company Name</th>
                                                    <th style={{ ...thStyle, width: '90px' }}>Phone Number</th>
                                                    <th style={{ ...thStyle, width: '90px' }}>Registration Date</th>
                                                    <th style={{ ...thStyle, width: '70px' }}>User Type</th>
                                                    <th style={{ ...thStyle, width: '90px' }}>Verification Status</th>
                                                    <th style={{ ...thStyle, width: '60px' }}>Actions</th>
                                                </tr>
                                            </thead>
                                        </table>
                                    </div>

                                    {/* Scrollable Body Table */}
                                    <div style={{
                                        maxHeight: "400px",
                                        overflowY: "auto",
                                        overflowX: 'hidden'
                                    }}>
                                        <table style={{
                                            width: "100%",
                                            borderCollapse: "collapse",
                                            tableLayout: 'fixed'
                                        }}>
                                            <tbody>
                                                {searchFilteredData.length ? (
                                                    searchFilteredData.map((c, idx) => {
                                                        // Get status from verificationStatus or status field
                                                        const userStatus = c.verificationStatus || c.status || "PENDING";
                                                        return (
                                                            <tr key={c.id || idx}>
                                                                <td style={{ ...thTdStyle, width: '50px' }}>{idx + 1}</td>
                                                                <td style={{ ...thTdStyle, width: '100px' }}>{c?.vendorName || "—"}</td>
                                                                <td style={{ ...thTdStyle, width: '80px' }}>{c?.userId || c?.id || "—"}</td>
                                                                <td style={{ ...thTdStyle, width: '120px' }}>{c?.email || "—"}</td>
                                                                <td style={{ ...thTdStyle, width: '100px' }}>{c?.companyName || "—"}</td>
                                                                <td style={{ ...thTdStyle, width: '90px' }}>{c?.mobileNumber || "—"}</td>
                                                                <td style={{ ...thTdStyle, width: '90px' }}>{formatDate(c?.registrationDate) || "N/A"}</td>
                                                                <td style={{ ...thTdStyle, width: '70px' }}>{c?.userType || "—"}</td>
                                                                <td style={{ ...thTdStyle, width: '90px' }}>
                                                                    <span className={`badge ${getStatusBadgeColor(userStatus)}`}>
                                                                        {getStatusDisplayText(userStatus)}
                                                                    </span>
                                                                </td>
                                                                <td style={{ ...thTdStyle, width: '60px' }}>
                                                                    <button
                                                                        style={{ ...buttonStyle, color: "rgb(230 109 51)", fontWeight: "bold" }}
                                                                        onClick={() => handleViewClick(c)}
                                                                    >
                                                                        View
                                                                    </button>
                                                                </td>
                                                            </tr>
                                                        );
                                                    })
                                                ) : (
                                                    <tr>
                                                        <td style={thTdStyle} colSpan={10}>
                                                            {rolesData.length === 0
                                                                ? "Loading data or no professional users found."
                                                                : (searchQuery.trim() || statusFilter)
                                                                    ? "No professional users found with the specified filters."
                                                                    : "No professional users match the current filters."}
                                                        </td>
                                                    </tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div className="mt-4 rounded-3 shadow-sm">
                                <div className="d-flex align-items-center mb-4">
                                    <button
                                        onClick={handleBackClick}
                                        className="btn fw-bold px-4 py-2"
                                        style={{ backgroundColor: "rgb(230 109 51)", color: "#fff" }}
                                    >
                                        Back to List
                                    </button>
                                    {companyVerificationData && (
                                        <div className="ms-3">

                                        </div>
                                    )}
                                </div>

                                {loading && (
                                    <div className="text-center my-4">
                                        <span className="spinner-border text-primary" />
                                    </div>
                                )}

                                {!loading && (
                                    <>
                                        <div className="register mt-4">
                                            <div className="registertable bo2">
                                                <table className="table table-bordered table-striped align-middle mt-4 w-100">
                                                    <thead>
                                                        <tr>
                                                            <th style={detailThStyle}>Field</th>
                                                            <th style={detailThStyle}>Value</th>
                                                            <th style={detailThStyle}>Image</th>
                                                            <th style={detailThStyle}>Status</th>
                                                        </tr>
                                                    </thead>

                                                    <tbody>
                                                        {rows.map((r, i) => {
                                                            const isEditing = r.isEditing || false;

                                                            const handleInputChange = (field, value) => {
                                                                setRows((prevRows) =>
                                                                    prevRows.map((row, idx) =>
                                                                        idx === i
                                                                            ? {
                                                                                ...row,
                                                                                value:
                                                                                    typeof row.value === "object"
                                                                                        ? { ...row.value, [field]: value }
                                                                                        : value,
                                                                            }
                                                                            : row
                                                                    )
                                                                );
                                                            };

                                                            // Handle Company Type selection
                                                            const handleCompanyTypeChange = (selectedValue) => {
                                                                setRows((prevRows) =>
                                                                    prevRows.map((row, idx) =>
                                                                        idx === i
                                                                            ? {
                                                                                ...row,
                                                                                value: selectedValue,
                                                                            }
                                                                            : row
                                                                    )
                                                                );
                                                            };

                                                            const handleImageChange = (e) => {
                                                                const files = Array.from(e.target.files);
                                                                const newImages = files.map((file) => ({
                                                                    url: URL.createObjectURL(file),
                                                                    file
                                                                }));

                                                                setRows(prev =>
                                                                    prev.map((row, idx) =>
                                                                        idx === i
                                                                            ? {
                                                                                ...row,
                                                                                images: [...(row.images || []), ...newImages]
                                                                            }
                                                                            : row
                                                                    )
                                                                );
                                                            };

                                                            return (
                                                                <tr key={r.key || i}>
                                                                    <td className="fw-bold text-center align-middle">{r.key}</td>

                                                                    <td className="text-start align-middle">
                                                                        {r.key === "Business Type" ? (
                                                                            isEditing ? (
                                                                                <select
                                                                                    value={r.value || ""}
                                                                                    onChange={(e) => handleCompanyTypeChange(e.target.value)}
                                                                                    className="form-select w-75"
                                                                                >
                                                                                    <option value="">Select Business Type</option>
                                                                                    {companyTypeOptions.map((option) => (
                                                                                        <option key={option} value={option}>
                                                                                            {companyTypeDisplayMap[option] || option}
                                                                                        </option>
                                                                                    ))}
                                                                                </select>
                                                                            ) : (
                                                                                companyTypeDisplayMap[r.value] || r.value || "N/A"
                                                                            )
                                                                        ) : r.key === "Owner Date of Birth" ? (
                                                                            isEditing ? (
                                                                                <input
                                                                                    type="date"
                                                                                    value={safeDateToISOString(r.value)}
                                                                                    onChange={(e) => handleInputChange("value", e.target.value)}
                                                                                    className="form-control d-inline-block w-75"
                                                                                />
                                                                            ) : (
                                                                                safeDateDisplay(r.value)
                                                                            )
                                                                        ) : r.key === "Incorporation Certificate" ? (
                                                                            "Incorporation Certificate"
                                                                        ) : r.key === "GST Certificate" ? (
                                                                            "GST Certificate"
                                                                        ) : r.key === "Trade License" ? (
                                                                            "Trade License"
                                                                        ) : r.key === "Owner PAN Document" ? (
                                                                            "Owner PAN Document"
                                                                        ) : r.key === "Owner Aadhaar Document" ? (
                                                                            "Owner Aadhaar Document"
                                                                        ) : r.key === "Owner Image" ? (
                                                                            "Owner Image"
                                                                        ) : r.key === "Company PAN Document" ? (
                                                                            "Company PAN Document"
                                                                        ) : (
                                                                            isEditing ? (
                                                                                <input
                                                                                    type="text"
                                                                                    value={r.value || ""}
                                                                                    onChange={(e) => handleInputChange("value", e.target.value)}
                                                                                    className="form-control d-inline-block w-75"
                                                                                />
                                                                            ) : (
                                                                                r.value || "N/A"
                                                                            )
                                                                        )}
                                                                    </td>

                                                                    <td className="text-center align-middle">
                                                                        {isImageField(r.key) ? (
                                                                            <>
                                                                                {isEditing && (
                                                                                    <input
                                                                                        type="file"
                                                                                        multiple={r.key === "Owner Aadhaar Document"}
                                                                                        accept="image/*,.pdf"
                                                                                        onChange={handleImageChange}
                                                                                        className="form-control mb-2"
                                                                                    />
                                                                                )}
                                                                                <ImageDisplay images={r.images} fieldName={r.key} />
                                                                            </>
                                                                        ) : (
                                                                            <span style={{ fontSize: "18px", color: "#6c757d" }}>-</span>
                                                                        )}
                                                                    </td>

                                                                    <td className="text-center align-middle">
                                                                        {isEditing ? (
                                                                            <>
                                                                                <button
                                                                                    className="btn btn-sm btn-success me-2"
                                                                                    style={{ minWidth: 80 }}
                                                                                    onClick={() => handleSaveRow(i)}
                                                                                >
                                                                                    Save
                                                                                </button>
                                                                                <button
                                                                                    className="btn btn-sm btn-secondary"
                                                                                    style={{ minWidth: 80 }}
                                                                                    onClick={() =>
                                                                                        setRows((prev) =>
                                                                                            prev.map((row, idx) =>
                                                                                                idx === i ? { ...row, isEditing: false } : row
                                                                                            )
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Cancel
                                                                                </button>
                                                                            </>
                                                                        ) : (
                                                                            <div style={{ display: "flex", gap: "10px" }}>
                                                                                <button
                                                                                    className="btn btn-sm btn-primary"
                                                                                    style={{ minWidth: 80 }}
                                                                                    onClick={() =>
                                                                                        setRows((prev) =>
                                                                                            prev.map((row, idx) =>
                                                                                                idx === i ? { ...row, isEditing: true } : row
                                                                                            )
                                                                                        )
                                                                                    }
                                                                                >
                                                                                    Edit
                                                                                </button>
                                                                            </div>
                                                                        )}
                                                                    </td>
                                                                </tr>
                                                            );
                                                        })}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>

                                        {/* Approve and Reject Buttons at Bottom - FIXED LAYOUT */}
                                        <div className="d-flex justify-content-center gap-3 mt-4 mb-4 p-3 border-top position-relative">
                                            <div className="d-flex gap-3 align-items-start position-relative">
                                                {/* Conditionally render Approve button or Approved status */}
                                                {companyVerificationData?.verificationStatus === "VERIFIED" || companyVerificationData?.verificationStatus === "APPROVED" ? (
                                                    <div className="d-flex align-items-center">
                                                        <span className="badge bg-success p-2 fs-6">Approved</span>
                                                    </div>
                                                ) : (
                                                    <button
                                                        className="btn btn-success px-4 py-2 fw-bold"
                                                        style={{ minWidth: "120px" }}
                                                        onClick={handleApproveAll}
                                                        disabled={isApproving || isRejecting}
                                                    >
                                                        {isApproving ? (
                                                            <>
                                                                <span className="spinner-border spinner-border-sm me-2"></span>
                                                                Approving...
                                                            </>
                                                        ) : (
                                                            "Approve"
                                                        )}
                                                    </button>
                                                )}

                                                {/* Conditionally render Reject button or nothing */}
                                                {companyVerificationData?.verificationStatus !== "VERIFIED" &&
                                                    companyVerificationData?.verificationStatus !== "APPROVED" && (
                                                        <div className="position-relative">
                                                            {showRejectDropdown ? (
                                                                <div className="card p-3 shadow-sm" style={{
                                                                    width: "300px",
                                                                    position: "absolute",
                                                                    top: "100%",
                                                                    left: "0",
                                                                    marginTop: "0px",
                                                                    zIndex: 1000
                                                                }}>
                                                                    <div className="mb-3">
                                                                        <label className="form-label fw-bold">Rejection Reason</label>
                                                                        <textarea
                                                                            className="form-control"
                                                                            rows="3"
                                                                            placeholder="Enter rejection reason..."
                                                                            value={rejectionDescription}
                                                                            onChange={(e) => setRejectionDescription(e.target.value)}
                                                                            disabled={isApproving || isRejecting}
                                                                        />
                                                                    </div>

                                                                    <div className="d-flex gap-2">
                                                                        <button
                                                                            className="btn btn-danger flex-grow-1"
                                                                            onClick={handleRejectAll}
                                                                            disabled={!rejectionDescription.trim() || isApproving || isRejecting}
                                                                        >
                                                                            {isRejecting ? (
                                                                                <>
                                                                                    <span className="spinner-border spinner-border-sm me-2"></span>
                                                                                    Rejecting...
                                                                                </>
                                                                            ) : (
                                                                                "Confirm Reject"
                                                                            )}
                                                                        </button>
                                                                        <button
                                                                            className="btn btn-secondary"
                                                                            onClick={() => {
                                                                                setShowRejectDropdown(false);
                                                                                setRejectionDescription("");
                                                                            }}
                                                                            disabled={isApproving || isRejecting}
                                                                        >
                                                                            Cancel
                                                                        </button>
                                                                    </div>
                                                                </div>
                                                            ) : (
                                                                <button
                                                                    className="btn btn-danger px-4 py-2 fw-bold"
                                                                    style={{ minWidth: "120px" }}
                                                                    onClick={() => setShowRejectDropdown(true)}
                                                                    disabled={companyVerificationData?.verificationStatus === "REJECTED" || isApproving || isRejecting}
                                                                >
                                                                    {isRejecting ? (
                                                                        <>
                                                                            <span className="spinner-border spinner-border-sm me-2"></span>
                                                                            Rejecting...
                                                                        </>
                                                                    ) : (
                                                                        "Reject"
                                                                    )}
                                                                </button>
                                                            )}
                                                        </div>
                                                    )}
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

const tableStyle = { width: "100%", borderCollapse: "collapse", marginTop: 5 };
const thTdStyle = { border: "1px solid #ddd", textAlign: "center", padding: "8px" };
const thStyle = { ...thTdStyle, backgroundColor: "rgb(230 109 51)", color: "#fff", fontWeight: "bold" };
const buttonStyle = { backgroundColor: "transparent", border: "none", cursor: "pointer" };

const detailThStyle = {
    ...thTdStyle,
    backgroundColor: "rgb(230 109 51)",
    color: "#fff",
    fontWeight: 600,
    padding: "0.75rem",
    verticalAlign: "middle",
    border: "1px solid #dee2e6",
    textAlign: "center"
};

export default ProfessionalUser;